// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Courier+Prime:wght@400;700&family=Montserrat:wght@100;300;400;500;600;700;800;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    cursor: default;
    margin: 0;
    padding: 0;
    font-family: sans-serif;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
}

.sidebarGeovista{
    left: 50px !important;
}

  #app {
    width: 100vw;
    height: 100vh;
    position: absolute;
    z-index: 1;
  }


label {
    display: flex;
    font-size: 13px;
    position: relative;
}

.fundoLegenda {
    top: 0px;
    right: 0px;
    z-index: 10;
    display: flex;
}

.legenda {
    background: #ffffff;
    padding-top: 10px;
    padding-right: 5px;
    min-width: 170px;
    max-width: 300px;
    max-height: 80vh;
    border: thin groove rgba(170, 170, 170, 0.596);
    position: fixed;
    right: -400px;
    bottom: 40px;
    border-radius: 10px 0px 0px 10px;
    overflow-x: hidden;
    overflow-y: auto;
    transition: 0.8s;
}

.legendRight{
  display: flex;
  /* position: relative; */
}

.chartSpacing{
  max-width: 60%;
  margin-left: 10px;
}

.chartSpacing div canvas{
  max-width: 100%;
  min-width: 100%;
  padding-top: 4px;
}

.changeTextColor{
  font-family: 'Courier Prime', monospace;
  white-space: nowrap;
  height: 23px;
  font-size: 10px;
}

.legendaChart {
  background: #fff;
  max-width: 70%;
  font-size: 13px;
  max-height: 100vw;
  overflow: hidden;
  transition: 0.8s;
  cursor: pointer;
  padding-top: 5px;
}

.legendaChart.centerRugosidadeLegend {
  padding-top: 10px;
}

.legendTitle{
  width: 100%;
  text-align: center;
  color: #a8a8a8;
  font-size: 15px;
  font-weight: bold;
  border-radius: 7px;
  border: 1px solid #a8a8a8;
  margin-bottom: 15px;
  transition: .5s;
}

.infoLegendBlocked{
  background: #fff;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  text-align: justify;
  opacity: 0;
  top: 0;
  left: 0;
  font-size: 12px;
  height: 100%;
  padding: 35px 5px;
  box-shadow: 0px 0px 15px #0000006c;;
  transition: .3s;
  z-index: 1;
}

.infoLegendBlocked.active{
  opacity: 1;
}

.arrowIcon{
  position: absolute;
  top: 1px;
  left: 6px;
  font-size: 26px;
}

.centerLegendaChart{
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.legenda.active{
    right: -1px;
}

#legendaIA {
    display: flex;
    width: 300px;
}

#legendaRugosidade {
    display: flex;
    min-width: 170px;
    max-width: 220px;
}

.legendMode{
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin: 0px 20px;
    margin-bottom: 10px;
    width: 87%;
}

.legendMode div{
    display: flex;
    justify-content: center;
    align-items: center;
}

.legendMode div span{
  padding: 4px 10px;
  border-radius: 7px;
  background: #cccccc;
  cursor: pointer;
  transition: .4s;
  font-weight: bold;
  color: #fff;
  border: 1px solid #e0e0e0;
}

.legendMode div span:hover{
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background: #6aaaff;
  border: 1px solid #a9ceff;
}

a:link {
  text-decoration: none;
}

a:visited {
  color: black;
  text-decoration: none;
}

a:hover {
  text-decoration: none;
}

a:active {
  text-decoration: none;
}

.trocarCor {
  margin-right: 10px;
  position: relative;
  background: #ffffffdc;
  vertical-align: middle;
  min-width: 18px;
  max-width: 18px;
  min-height: 18px;
  max-height: 18px;
  border: 2px solid #3a3a3adc;
  margin-bottom: 5px;
  border-radius: 10px;
}

.trocarCor.rugosidadeLegend{
  min-width: 40px;
  max-width: 40px;
  min-height: 11px;
  max-height: 11px;
  border-radius: 1px;
}

.tampa {
  margin-right: -18px;
  margin-bottom: -2px;
  position: relative;
  background: white;
  display: flex;
  min-width: 18px;
  max-width: 18px;
  min-height: 18px;
  max-height: 18px;
  z-index: 200;
  border-radius: 10px;
  display: inline-block;
}

.tampa.rugosidadeLegend{
  margin-right: -40px;
  margin-bottom: 0px;
  min-width: 40px;
  max-width: 40px;
  min-height: 11px;
  max-height: 11px;
  border-radius: 1px;
}

.timeControlCenter{
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 100%;
  max-width: 100%;
  height: 100%;
  border-top: 1px solid #c7c7c7;
}

.TimeControl {
  display: grid;
  grid-template-columns: 42px 1fr;
  background: #ffffff;
  padding-right: 5px;
  padding-left: 2px;
  width: 100%;
  height: 100%;
  border-radius: 10px ;
  transition: .5s;
}

.TimeControl.active {
  bottom: 245px
}

.TimeControl.disable {
  bottom: -200px
}

.calendarButton{
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.restoreButton {
  font-size: 16px;
  height: 25px;
  width: 25px;
  border-radius: 50%;
  margin: 2px 0px;
  border: none;
  background: #d9d9d9;
  cursor: pointer;
  color: white;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: .5s;
}

.restoreButton:hover {
    background: #c0c0c0
}

.centerElement{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}

.slideCenter{
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 60px 1fr 20px;
  margin: 0px;
}

.output{
  width: 55px;
  color: #666666;
}

.slider {
  -webkit-appearance: none;
  height: 5px;
  border-radius: 5px;  
  background: #acacac;
  outline: none;
  opacity: 0.7;
  transition: .2s;
  width: 100%;
}

.slider::-webkit-slider-thumb {
  appearance: none;
  width: 15px;
  height: 15px;
  border-radius: 50%; 
  background: #646464;
  cursor: pointer;
}

.slider::-moz-range-thumb {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: #646464;
  cursor: pointer;
}

#fundoMouseRight {
    pointer-events: none;
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0px;
    left: 0px;
    display: none;
    z-index: 3000;
}

#bordaCirculo {
    pointer-events: all;
    position: absolute;
    z-index: 5;
    margin-left: 6px;
    margin-top: 6px;
    width: 130px;
    height: 130px;
    border: 30px solid rgba(187, 187, 187, 0.77);
    -webkit-backdrop-filter: blur(6px);
            backdrop-filter: blur(6px);
    border-radius: 50%;
}

#clickMouseRight1 {
    position: absolute;
    margin-left: -30px;
    margin-top: -30px;
    width: 63px;
    height: 65px;
    border-radius: 100% 0px 0px;
}

#clickMouseRight2 {
    position: absolute;
    margin-left: 37px;
    margin-top: -30px;
    width: 63px;
    height: 65px;
    border-radius: 0px 100% 0px 0px;
}

#clickMouseRight3 {
    position: absolute;
    margin-left: -30px;
    margin-top: 39px;
    width: 63px;
    height: 61px;
    border-radius: 0px 0px 0px 100%;
}

#clickMouseRight4 {
    position: absolute;
    margin-left: 37px;
    margin-top: 39px;
    width: 63px;
    height: 61px;
    border-radius: 0px 0px 100% 0px;
}

#clickMouseRight5 {
    position: absolute;
    margin-left: 3px;
    margin-top: 3px;
    width: 64px;
    height: 64px;
    border-radius: 100%;
}

.iconeMouseRight {
    width: 28px;
    position: absolute;
    margin-top: 17px;
    margin-left: 17px;
    filter: invert(100%);
}

@supports (-moz-appearance: none) {
    #clickMouseRight5 {
        background-color: rgb(255, 255, 255);
        position: absolute;
        margin-left: 0px;
        margin-top: 0px;
        width: 70px;
        height: 70px;
        border-radius: 100%;
    }

    #clickMouseRight1:hover {
        background-color: rgba(168, 168, 168, 0.77);
    }

    #clickMouseRight2:hover {
        background-color: rgba(168, 168, 168, 0.77);
    }

    #clickMouseRight3:hover {
        background-color: rgba(168, 168, 168, 0.77);
    }

    #clickMouseRight4:hover {
        background-color: rgba(168, 168, 168, 0.77);
    }
}

#clickMouseRight1:hover {
    -webkit-backdrop-filter: brightness(0.8);
            backdrop-filter: brightness(0.8);
}

#clickMouseRight2:hover {
    -webkit-backdrop-filter: brightness(0.8);
            backdrop-filter: brightness(0.8);
}

#clickMouseRight3:hover {
    -webkit-backdrop-filter: brightness(0.8);
            backdrop-filter: brightness(0.8);
}

#clickMouseRight4:hover {
    -webkit-backdrop-filter: brightness(0.8);
            backdrop-filter: brightness(0.8);
}

.infoMouseRight {
    margin-left: -42px;
    margin-top: 105px;
    width: 150px;
    height: 30px;
    text-align: center;
}

* {
    margin: 0;
    padding: 0;
}

.formLabel {
    width: 215px;
    margin-left: 20px;
    border: solid 1px white;
    color: white;
    font-weight: bold;
    font-size: 12px;
    background: #2f77e4;
    padding: 2px 7px 2px 7px;
    border-radius: 0px 10px 10px 10px;
}

.allFilters{
    padding-top: 15px;
    margin-left: -500px;
    opacity: 0;
    transition: opacity .3s, margin-left 0.8s;
}

.allFilters.active {
    margin-left: -10px;
    opacity: 1;
}

.topspace{
    padding-top: 15px;
}

.tight-gutter {
    padding: 0 2px;
}

.filterButton{
    position: absolute;
    margin-top: 8px;
    right: 5%;
    padding: 2px 5px 2px 5px;
    font-size: 12px;
}

.noFilterButton{
    cursor: pointer;
    color: #2f77e4 !important;
    font-weight: 600;
    position: absolute;
    margin-top: 10px;
    left: 5%;
    padding: 2px;
    font-size: 10px;
}

.noFilterButton:hover{
    font-weight: 1000;
}

.stopCaptureButton{
    top: 37px;
    left: 105px;
    font-size: 0px;
    padding-top: 3px;
    text-align: center;
    color: white;
    border: solid 1px rgba(0, 0, 0, 0.541);
    width: 0;
    height: 0;
    background:#2f77e4;
    border-radius: 0px 10px 10px 10px;
    border: none;
    z-index: 500;
    position: absolute;
    transition: width 0.5s, height 0.5s, top 0.5s, font-size 0.5s;
}

.stopCaptureButton.active{
    width: 150px;
    height: 30px;
    top: 37px;
    font-size: 15px;
}

.emailFormCenter {
    pointer-events: none;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, .5);
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 2000;
    display: none;
    opacity: 0;
    justify-content: center;
    align-items: center;
    transition: opacity 0.8s;
}
.emailFormCenter.active{
    pointer-events: all;
    display: flex;
    transition: opacity 0.8s;
}

.emailFormCenter.opacity{
    opacity: 1;
}

.emailFormBody{
    align-items: center;
    border: solid 1px rgba(0, 0, 0, 0.575);
    pointer-events: none;
    position: relative;
    width: 0;
    height: 0;
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 10px 12px 20px rgba(0, 0, 0, 0.2);;
    padding: 20px;
    transition: height 0.8s, width 0.8s, top 0.8s;
}

.emailFormBody.active {
    width: 400px;
    height: 350px;
    pointer-events: all;
}

.formEmail{
    opacity: 0;
    transition: opacity 0.1s;
}

.formEmail.active{
    opacity: 1;
}

.formInputEmail{
    border-radius: 5px;
    border: none;
    padding: 2px 7px 2px 7px;
    font-size: 12px;
    width: 100%;
    border: solid 1px rgb(124, 124, 124);
}

.formLabelEmail {
    border: solid 1px white;
    color: white;
    font-weight: bold;
    font-size: 12px;
    background: #2f77e4;
    padding: 2px 7px 2px 7px;
    border-radius: 0px 10px 10px 10px;
}

.topmargin{
    margin-top: 10px;
}
.sendEmailButton{
    top: 25px;
    left: 105px;
    font-size: 0px;
    padding-top: 3px;
    text-align: center;
    color: white;
    border: solid 1px rgba(0, 0, 0, 0.541);
    width: 0;
    height: 0;
    background:#2f77e4;
    border-radius: 0px 10px 10px 10px;
    border: none;
    z-index: 500;
    position: absolute;
    transition: width 0.5s, height 0.5s, top 0.5s, font-size 0.5s;
}

.sendEmailButton.active{
    width: 160px;
    height: 52px;
    top: 36px;
    font-size: 15px;
}

.cancelCaptureText{
    cursor: pointer;
    opacity: 0;
    transition: opacity 1s;
}

.cancelCaptureText.active{
    opacity: 1;
}

.sendEmailText{
    cursor: pointer;
    opacity: 0;
    transition: opacity 1s;
}

.sendEmailText.active{
    opacity: 1;
}

.graphicsPanel{
    padding: 10px;
    position: absolute;
    background-color: white;
    width: 0;
    height: 0;
    right: -300px;
    top: 15px;
    border: solid 1px rgba(0, 0, 0, 0.514);
    border-radius: 15px;
    z-index: 100;
    /* box-shadow: 7px 7px 5px 1px rgba(0, 0, 0, 0.2); */
    transition: width .8s, height .8s, right .8s;
}

.graphicsPanel.active{
    width: 350px;
    height: 350px;
    right: 205px;
}

/*^autocomplete*/
.autocomplete {
    position: relative;
    display: inline-block;
  }
  
  .autocomplete-items {
    background-color: #fff;
    color: black;
    position: absolute;
    top: 29px;
    border: 1px solid #e9e8e8;
    border-top: none;
    border-radius: 0px 0px 5px 5px;
    width: 95%;
    max-height: 180px;
    font-size: 12px;
    z-index: 1000;
    overflow-y: auto;
    overflow-x: hidden;
  }
  
  .autocomplete-items div {
    padding: 10px;
    cursor: pointer;
    background-color: #fff; 
  }
  
  .autocomplete-items div:hover {
    background-color: #e9e9e9; 
  }
  
  .autocomplete-active {
    background-color: DodgerBlue !important; 
    color: #fff; 
  }
  /*\$autocomplete*/

  .background {
	width: 100vw;
	height: 100vh;
	background: rgba(0, 0, 0,.5);
	position: fixed;
	top: 0px;
	left: 0px;
	z-index: 200000;
	display: none;
	justify-content: center;
	align-items: center;
}

.background.show {
	display: flex;
}

.loading{
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	height: 40px;
	display: flex;
	align-items: center;
}

.obj{
	width: 12px;
	height: 70px;
	background: white;
	margin: 0 3px;
	border-radius: 10px;
	animation: loading 0.8s infinite;
}
.obj:nth-child(2){
	animation-delay: 0.1s;
}
.obj:nth-child(3){
	animation-delay: 0.2s;
}
.obj:nth-child(4){
	animation-delay: 0.3s;
}
.obj:nth-child(5){
	animation-delay: 0.4s;
}
.obj:nth-child(6){
	animation-delay: 0.5s;
}
.obj:nth-child(7){
	animation-delay: 0.6s;
}
.obj:nth-child(8){
	animation-delay: 0.7s;
}


@keyframes loading{
	0%{
		height: 0;
	}
	50%{
		height: 70px;
	}
	100%{
		height: 0;
	}
}

.NebulaCentral{
    z-index: 400;
    top: 15px;
    right: 15px;
    position: absolute;
    color: white;
    -webkit-user-select: none;
            user-select: none;
    transition: 0.4s;    
    width: 180px;
    transition: .8s;
}

.NebulaCentral.disable{
    right: -300px;
}

.NebulaCentral h3{  
    border-radius: 5px 5px 0px 0px;
    background: #106bca; 
    line-height: 90%;
    text-align: center;
    font-size: 15px;
    padding: 10px;
    padding-bottom: 20px;
}

.controlNebula ul{
    border-radius: 5px;
    background-color: #106bca;
    margin-top: -20px;
}

.controlNebula ul li{
    background: #106bca;  
    text-align: center;
    list-style-type: none;
    padding: 2px;
    border-radius: 5px;
    font-size: 13px;    
    transition: 0.4s;    
    cursor: pointer;
}

.controlNebula ul li:hover{
    font-size: 20px;
    font-weight: bold;
}

.controlNebula ul li:active{
    font-size: 20px;
    font-weight: bold;
    background-color: rgb(255, 255, 255);
}

.zoomPanel{
    position: absolute;
    z-index: 2000;
    display: inline-block;
    height: 20px;
    width: 130px;
    max-width: 20vw;
    background: rgb(248, 248, 248);
    color: rgba(0, 0, 0, 0.719);
    box-shadow: 2px 2px 5px 1px rgba(0, 0, 0, 0.2);
    border-radius: 50px;
    right: 20px;
    bottom: 10px;
    font-weight: bold;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    transition: .8s;
}

.zoomPanelSecond{
    position: absolute;
    z-index: 2000;
    display: inline-block;
    height: 20px;
    width: 130px;
    max-width: 20vw;
    background: rgb(248, 248, 248);
    color: rgba(0, 0, 0, 0.719);
    box-shadow: 2px 2px 5px 1px rgba(0, 0, 0, 0.2);
    border-radius: 50px;
    right: 5px;
    bottom: 5px;
    font-weight: bold;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    transition: .8s;
}

.zoomPanel.move{
    right: -200px;
}

.zoomControlMinus{
    display: inline-block;
    background: rgb(255, 255, 255);
    border-radius: 50px 0px 0px 50px;
    height: 100%;
    width: 38%; 
    transition: .5s;
}

.zoomControlMinus:hover{
    background: linear-gradient(to left, rgb(255, 255, 255) , rgb(238, 238, 238));
    transition: .2s;
}

.zoomControlMinus:active{
    background: linear-gradient(to left rgb(255, 255, 255) , rgb(233, 233, 233));
    transition: .2s;
}

.zoomControlPlus{
    display: inline-block;
    background: rgb(255, 255, 255);
    border-radius: 0px 50px 50px 0px;
    height: 100%;
    width: 38%; 
    margin-left: 2px;
    transition: .5s;
}

.zoomControlPlus:hover{
    background: linear-gradient(to right, rgb(255, 255, 255) , rgb(238, 238, 238));
    transition: .2s;
}

.zoomControlPlus:active{
    background: linear-gradient(to right, rgb(255, 255, 255) , rgb(233, 233, 233));
    transition: .2s;
}

.minusSymbol{
    position: absolute;
    margin-bottom: -5px;
    bottom: 1px;
    left: 15px;
    font-size: 20px;
}

.plusSymbol{
    position: absolute;
    margin-bottom: -4px;
    bottom: 1px;
    right: 15px;
    font-size: 17px;
}

.orientation{
    display: inline-block;
    background: rgb(255, 255, 255);
    height: 100%;
    width: 20%; 
    margin-left: 2px;
    transition: .2s;
    text-align: center;
}

.orientation:hover{
    background: rgb(248, 248, 248);
}

.orientation:active{
    background: rgb(240, 240, 240);
}

.orientation i{
    color: #000;
    position: absolute;
    margin-left: -8px;
    margin-top: 2px;
    font-size: 17px;
    height: 32px;
    vertical-align: middle;
}

.calendarHub{
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  /* justify-content: center; */
  min-height: 270px;
  bottom: -270px;
  overflow: hidden;
  left: -100vw;
  opacity: 0;
  transition: .5s;
  z-index: 10 !important;
}

.calendarHub.active{
  bottom: -270px;
  opacity: 1;
  left: 0px;
}

.calendarModule{
  -webkit-user-select: none;
          user-select: none;
  padding: 6px;
  background: #fff;
  color: #2f77e4;
  border: solid 1px #c7c7c7;
  border-left: none;
  border-radius: 0px 10px 10px 0px;
  width: 80%;
  cursor: pointer;
  position: relative;
  z-index: 20000;
}

.react-calendar {
    /* width: 300px; */
    max-width: 100%;
    background: white;
    border: 1px solid #a0a096;
    font-family: Arial, Helvetica, sans-serif;
    line-height: 1.125em;
    font-size: 16px;
  }
  .react-calendar--doubleView {
    width: 700px;
  }
  .react-calendar--doubleView .react-calendar__viewContainer {
    display: flex;
    margin: -0.5em;
  }
  .react-calendar--doubleView .react-calendar__viewContainer > * {
    width: 50%;
    margin: 0.5em;
  }
  .react-calendar,
  .react-calendar *,
  .react-calendar *:before,
  .react-calendar *:after {
    box-sizing: border-box;
  }
  .react-calendar button {
    margin: 0;
    border: 0;
    outline: none;
  }
  .react-calendar button:enabled:hover {
    cursor: pointer;
  }
  .react-calendar__navigation {
    display: flex;
    height: 44px;
    margin-bottom: 1em;
  }
  .react-calendar__navigation button {
    min-width: 44px;
    background: none;
  }
  .react-calendar__navigation button:disabled {
    background-color: #f0f0f0;
  }
  .react-calendar__navigation button:enabled:hover,
  .react-calendar__navigation button:enabled:focus {
    background-color: #e6e6e6;
  }
  .react-calendar__month-view__weekdays {
    text-align: center;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 16px;
  }
  .react-calendar__month-view__weekdays__weekday {
    padding: 0.5em;
  }
  .react-calendar__month-view__weekNumbers .react-calendar__tile {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: bold;
  }
  .react-calendar__month-view__days__day--weekend {
    color: #d10000;
  }
  .react-calendar__month-view__days__day--weekend:disabled {
    color: #d1000067;
  }
  .react-calendar__month-view__days__day--neighboringMonth {
    color: #757575;
  }
  .react-calendar__year-view .react-calendar__tile,
  .react-calendar__decade-view .react-calendar__tile,
  .react-calendar__century-view .react-calendar__tile {
    padding: 15px;
  }
  .react-calendar__tile {
    max-width: 100%;
    padding: 10px 6.6667px;
    background: none;
    text-align: center;
    line-height: 16px;
  }
  .react-calendar__tile:disabled {
    background-color: #f0f0f0;
  }
  .react-calendar__tile:enabled:hover,
  .react-calendar__tile:enabled:focus {
    background-color: #e6e6e6;
  }
  .react-calendar__tile--now {
    background: #ffff76;
  }
.react-calendar__tile--now:enabled:hover,
.react-calendar__tile--now:enabled:focus {
    background: #ffffa9;
}
.react-calendar__tile--hasActive {
    background: #76baff;
}
.react-calendar__tile--hasActive:enabled:hover,
.react-calendar__tile--hasActive:enabled:focus {
    background: #a9d4ff;
}
.react-calendar__tile--active {
    background: #1087ff;
    color: white;
}
.react-calendar__tile--active.active {
    background: #000000;
    color: white;
}
.react-calendar__tile--active:enabled:hover,
.react-calendar__tile--active:enabled:focus {
    background: #1087ff;
}
.react-calendar--selectRange .react-calendar__tile--hover {
    background-color: #e6e6e6;
}

.mapboxgl-popup-content {
    background-color: #fff !important;
    /* border-radius: 20px !important; */
    border: solid 1px #000 !important;
    box-shadow: 5px 5px 6px #00000041 !important;
    transition: .4s !important;
}

.mapboxgl-popup-anchor-top .mapboxgl-popup-tip,
.mapboxgl-popup-anchor-top-left .mapboxgl-popup-tip,
.mapboxgl-popup-anchor-top-right .mapboxgl-popup-tip {
    border-bottom-color: #fff !important;
}
.mapboxgl-popup-anchor-bottom .mapboxgl-popup-tip,
.mapboxgl-popup-anchor-bottom-left .mapboxgl-popup-tip,
.mapboxgl-popup-anchor-bottom-right .mapboxgl-popup-tip {
    border-top-color: #fff !important;
}
.mapboxgl-popup-anchor-left .mapboxgl-popup-tip {
    border-right-color: #fff !important;
}
.mapboxgl-popup-anchor-right .mapboxgl-popup-tip {
    border-left-color: #fff !important;
}

.popupFormat{
    display: flex;
}

.popupFormatInfo{
    padding: 0px 10px;
}

#popupInfo{
    position: absolute;
    opacity: 0;
    max-width: 800px;
    max-height: 200px;
    background: #fff;
    white-space: nowrap;
    border: solid 1px #d4d4d4;
    border-radius: 10px;
    padding: 3px;
    font-size: 14px;
    z-index: 20000;
    pointer-events: none;
    transition: .2s;
}

.restoreMap {
    overflow: hidden;
    position: absolute;
    z-index: 30500;
    -webkit-user-select: none;
            user-select: none;
    top: -20px;
    left: 95px;
    margin-top: -50px;
    padding-top: 12px;
    background: #fff;
    color: #2f77e4;
    text-align: center;
    border: solid 1px rgba(0, 0, 0, 0.541);
    border-radius: 0px 0px 10px 10px;
    font-size: 14px;
    line-height: 15px;
    height: 50px;
    width: 33px;
    pointer-events: none;
    cursor: pointer;
    transition: .5s;
    box-shadow: 5px 12px 5px 1px rgba(0, 0, 0, 0.2);
}

.restoreMap.active {
    width: 150px;
    height: 72px;
    top: 36px;
    pointer-events: all;
}

.restoreMap ul li {
    list-style: none;
    padding: 7px;
}

.restoreMap ul li.active {
    background: #2f77e4;
    color: #fff;
    width: 100%;
    height: 100%;
}

#rectCanvas{
    z-index: 9000;
    position: absolute;
    /* background: rgba(255, 0, 0, 0.534); */
}

.titleFormat{
    display: flex;
    font-size: 23px;
    font-weight: bold;
    max-width: 200px;
}

.titleInfo{
    padding-left: 3px;
}

.dateInfo{
    color: #84DAFF;
}

.contentFormat{
    font-family: 'Courier Prime', monospace;
    color: #666666;
    padding-left: 3px;
    padding-top: 10px;
    font-size: 12px;
}

.contentFormat p{
    margin: 0px;
}

.centerConditionElement{
  height: 25px;
  width: 100%;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.conditionElement{
  font-family: 'Montserrat', sans-serif;
  font-weight: bold;
  font-size: 11px;
  height: 100%;
  width: 90%;
  color: #646464;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.conditionElement.ativa{
  background: #fff500;
}

.conditionElement.encerrada{
  background: #75ff93;
}

.expandImageButton{
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  right: 2%;
  top: 2%;
  color: #ffffffa8;
  -webkit-text-stroke: 1px #b8b8b8; /* Largura e cor do contorno */
  border-radius: 50%;
  cursor: pointer;
  font-size: 30px;
  font-weight: bold;
  width: 40px;
  height: 40px;
  z-index: 111000;
}

.expandImageButton:hover{
  color: #ffffff;
}

#fundoExpandedImage{
    position: absolute;
    left: 0px;
    top: 0px;
    display: flex;
    justify-content: center;
    align-items: initial;
    padding-top: 30px;
    background: rgba(0, 0, 0, 0.37);
    width: 100vw;
    height: 100vh;
    z-index: 10000;
    opacity: 0;
    pointer-events: none;
    transition: .2s;
    overflow: auto;
}

.closeExpandedImage{
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  right: 5.2%;
  top: 5.2%;
  color: #ffffffa8;
  -webkit-text-stroke: 1px #b8b8b8; /* Largura e cor do contorno */
  border-radius: 50%;
  cursor: pointer;
  font-size: 45px;
  font-weight: bold;
  width: 40px;
  height: 40px;
  z-index: 111000;
}
  
.closeExpandedImage:hover{
  color: #ffffff;
}

#expandedImage{
    position: absolute;
    /* top: -120vh; */
}

#rectCanvasExpanded{
    position: absolute;
    z-index: 110000;
    /* background: rgba(255, 0, 0, 0.473); */
}

/* ::-webkit-scrollbar {
    width: 5px;
} */
  
/* Track */
::-webkit-scrollbar-track {
    background: #ffffff;
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: #bbbbbb;
    border-radius: 10px;
}

.FilterCentral {
    z-index: 400;
    color: #666666;
    -webkit-user-select: none;
            user-select: none;
    transition: 0.4s;
    width: 100%;
}

.FilterCentral h3 {
    width: 100%;
    background: #fff;
    line-height: 90%;
    text-align: center;
    font-size: 15px;
    font-weight: bold;
    padding: 10px;
    padding-bottom: 20px;
}

.controlFilter{
    width: 100%;
    font-family: 'Montserrat', sans-serif;
}

.controlFilter ul {
    display: grid;
    width: 100%;
    grid-template-columns: 1fr 1fr;
    background-color: #fff;
    margin-bottom: 0px;
}

.lastFilterElement {
    grid-column-start: 1;
    grid-column-end: 3;
    grid-row-start: 3;
    grid-row-end: 3;
}

.controlFilter ul li {
    background: #fff;
    text-align: center;
    list-style-type: none;
    border-radius: 8px;
    padding: 1px;
    font-size: 12px;
    transition: 0.4s;
    cursor: pointer;
}

.controlFilter ul li:active {
    background-color: rgb(255, 255, 255);
}

.controlFilter ul li.active {
    background-color: rgb(235, 235, 235);
    color: #000;
}

.barraFilter{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 2px;
    margin-left: 0px;
  }
  
  .completeLabel{ 
    width: 100%; 
    margin-top: 3px;
}

.completeLabel form{ 
    display: flex;
    justify-content: center;
    align-items: center;
}

.formInput {
    width: 100%;
    border-radius: 0px;
    padding: 2px 7px 2px 7px;
    padding-left: 30px;
    font-size: 12px;
    border: solid 1px #b9b9b9;
    border-left: none;
    border-right: none;
    margin-left: 0px;
}

span.fas.fa-search {
  position: absolute;
  top: 15px;
  left: 7px;
  transform: translateY(-50%);
  color: #888;
  font-weight: 500;
  font-size: 14px;
}

.topElement{
    -webkit-user-select: none;
            user-select: none;
    align-items: center;
    background: #fff;
    position: sticky;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 90px;
    z-index: 2;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.5);
}

.classDescription{
    font-size: 11px;
    color: #666666;
    font-family: 'Courier Prime', monospace;
    width: 100%;
}

#fundoSplashScreen {
  z-index: 10000;
  -webkit-user-select: none;
          user-select: none;
  overflow: hidden;
  margin: 0px;
  padding: 0px;
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: slide-up .4s;
}


.loader {
  border: 8px solid #f3f3f3;
  border-top: 8px solid #3498db;
  border-radius: 50%;
  width: 250px;
  height: 250px;
  animation: spin 2.5s linear infinite;
  margin: 0 auto;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
    /* ângulo inicial da animação */
  }

  100% {
    transform: rotate(360deg);
    /* ângulo final da animação */
  }
}

.splash {
  z-index: 10;
  pointer-events: none;
  position: relative;
  width: 250px;
  height: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  border-radius: 50%;
  margin-top: -200px;
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
}

.splash.start {
  animation: startAnimation 4s;
  animation-timing-function: ease-in-out;
}

.splash.finish {
  animation: finishAnimation 3s;
}

.splash-text {
  position: absolute;
  font-weight: bold;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 30px;
  color: #fff;
}

.splash-text.finish {
  animation: finishAnimation 3s;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.1);
  }

  100% {
    transform: scale(0);
  }
}

@keyframes startAnimation {
  0% {
    opacity: 0;
    transform: scale(-1) translateY(-200%) translateX(200%);
  }

  50% {
    opacity: 1;
    transform: scale(1.5);
  }

  100% {
    transform: scale(1);
  }

}

@keyframes finishAnimation {
  0% {
    color: #fff;
    background: transparent;
    transform: scale(1);
    opacity: 1;
  }

  20% {
    color: #fff;
    background: transparent;
    transform: scale(1.5);
    opacity: 1;
  }

  50% {
    color: #dddddd;
    background: #dddddd;
    transform: scale(15);
    opacity: 1;
  }

  90% {
    color: #dddddd;
    background: #dddddd;
    transform: scale(0) translateY(-50%) translateX(50%);
    opacity: 1;
  }

  100% {
    color: #dddddd;
    background: #dddddd;
    transform: scale(0);
    opacity: 0;
  }
}

@keyframes slide-up {
  0% {
    transform: translateY(-200%);
  }

  100% {
    transform: translateY(0);
  }
}

/* City css */

.road {
  width: 100%;
  height: 80px;
  background-color: #636363;
  position: absolute;
  bottom: 0;
}

.line {
  width: 100%;
  border-bottom: 10px dashed yellow;
  margin-top: 30px;
  height: 20px;
}

.sidewalk {
  width: 100%;
  height: 20px;
  background-color: #8d8d8d;
  position: absolute;
  bottom: 80px;
}

.building {
  z-index: 1;
  overflow: hidden;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 150px;
  height: 300px;
  background-color: #808080;
  position: absolute;
  bottom: 100px;
  left: 50%;
  border-radius: 2px 2px 0px 0px;
  transform: translateX(-50%);
}

.building div {
  border-radius: 2px;
  margin: 10px;
  width: 30px;
  height: 40px;
  background-color: #505050;
}

.building div.active {
  background-color: #ffff65;
  box-shadow: 0 0px 40px #ffff65;
}

/* .building div.active:hover {
  background-color: #505050;
  box-shadow: none;
}

.building div:hover {
  background-color: #ffff65;
  box-shadow: 0 0px 40px #ffff65;
} */

.sun {
  width: 150px;
  height: 150px;
  background-color: #ffdb58;
  border-radius: 50%;
  position: absolute;
  bottom: 120px;
  left: 60px;
}

.sky {
  width: 100vw;
  height: 100vh;
  background-image: linear-gradient(#083647, #1b4261);
  position: absolute;
  top: 0;
}

.moon {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: #ebebeb;
  position: absolute;
  box-shadow: 0 0px 60px #fff;
  right: 20%;
  top: 10%;
}

.star {
  position: absolute;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 1s;
}

.star:hover {
  transform: scale(4);
}

.star1 {
  position: absolute;
  border-radius: 50%;
  background-color: #fff;
  width: 2px;
  height: 2px;
  box-shadow: 0 0px 30px #fff;
  animation: star1 2s infinite;
}

.star2 {
  position: absolute;
  border-radius: 50%;
  background-color: #fff;
  width: 2px;
  height: 2px;
  box-shadow: 0 0px 30px #fff;
  animation: star2 3s infinite;
}

.star3 {
  position: absolute;
  border-radius: 50%;
  background-color: #fff;
  width: 2px;
  height: 2px;
  box-shadow: 0 0px 30px #fff;
  animation: star3 4s infinite;
}

/* Keyframe animations for stars */
@keyframes star1 {

  0%,
  100% {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }
}

@keyframes star2 {

  0%,
  100% {
    opacity: 0;
  }

  25%,
  75% {
    opacity: 1;
  }
}

@keyframes star3 {

  0%,
  100% {
    opacity: 0;
  }

  33.333%,
  66.666% {
    opacity: 1;
  }
}

.cloud {
  z-index: 1;
  width: 200px;
  height: 100px;
  background-color: #193d4c;
  position: absolute;
  top: 30px;
  left: -50px;
  border-radius: 50px;
  animation: cloudMove 290s linear infinite;
}

@keyframes cloudMove {
  0% {
    transform: translateX(0px);
  }

  100% {
    transform: translateX(3000px);
  }
}

.car {
  z-index: 4;
  position: absolute;
  right: -650px;
  bottom: 65px;
  width: 180px;
  height: 40px;
  background-color: #910000;
  border-radius: 10px;
  animation: drive 35s linear infinite;
  box-shadow: 0 20px 20px rgba(0, 0, 0, 0.692);
}

.car2 {
  z-index: 4;
  position: absolute;
  right: -300px;
  bottom: 65px;
  width: 180px;
  height: 40px;
  background-color: #1714aa;
  border-radius: 10px;
  animation: drive 35s linear infinite;
  box-shadow: 0 20px 20px rgba(0, 0, 0, 0.692);
}

.wheel {
  width: 40px;
  height: 40px;
  background-color: black;
  position: absolute;
  bottom: -15px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.wheel div {
  width: 23px;
  height: 23px;
  background-color: rgb(148, 148, 148);
  position: absolute;
  border-radius: 50%;
}

.wheel.left {
  left: 20px;
}

.wheel.right {
  right: 20px;
}

.teto {
  width: 130px;
  height: 80px;
  background-color: #910000;
  position: absolute;
  border-radius: 20px;
  bottom: 0px;
  left: 50%;
  transform: translateX(-45px);
}

.teto2 {
  width: 130px;
  height: 80px;
  background-color: #1714aa;
  position: absolute;
  border-radius: 20px;
  bottom: 0px;
  left: 50%;
  transform: translateX(-45px);
}

.window {
  width: 90%;
  height: 35px;
  background-color: #0f0f0f;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 7px;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 10px 10px 3px 3px;
}

.window div {
  width: 10px;
  height: 100%;
  background-color: #910000;
}

#roadDetections {
  position: absolute;
  height: 40px;
  bottom: 40px;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

#roadDetections div {
  position: relative;
  /* opacity: 0; */
  background: transparent;
  opacity: 1;
  height: 30px;
  min-width: 30px;
  max-width: 30px;
  border-radius: 50%;
  margin: 0px 5px;
  transition: .6s;
  /* margin-top: -20px; */
}

.detect {
  z-index: 1;
  top: 0px;
  left: -4px;
  position: absolute;
  background: transparent;
  min-width: 30px;
  max-width: 30px;
  border-radius: 50%;
}

.tampaDePV {
  z-index: 0;
  top: -27px;
  left: 0px;
  position: absolute;
  height: 23px !important;
  min-width: 23px !important;
  max-width: 23px !important;
  border: 3px solid #555555;
  background: #818181 !important;
  color: #5e5e5e;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 24px;
}

.tampaDePV div {
  position: absolute;
  top: -3px;
}

.buraco {
  z-index: 0;
  top: -27px;
  left: -9px;
  position: absolute;
  height: 23px !important;
  min-width: 40px !important;
  max-width: 40px !important;
  border-top: 2px solid #555555;
  background-image: linear-gradient(#575757, #555555, #2b2b2b) !important;
  border-radius: 30%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 50px;
  overflow: hidden;
}

.buraco div {
  z-index: 2;
  position: absolute;
  top: 3px;
  left: 0px;
  font-size: 40px;
  width: 30px !important;
  height: 20px !important;
  background: #666666 !important;
}

.lixeira {
  z-index: 3;
  color: #575757;
  font-size: 32px;
  position: absolute;
  top: -73px;
  left: -3px;
}

.lixeira i {
  position: absolute;
  z-index: 2 !important;
}

.lixeira div {
  position: absolute;
  z-index: 0 !important;
  left: 0px;
  top: 18px;
  height: 13px !important;
  min-width: 20px !important;
  max-width: 20px !important;
  box-shadow: 0 10px 15px #000000;
}

.bocaDeLobo {
  background: rgb(22, 22, 22) !important;
  min-width: 70px !important;
  max-width: 70px !important;
  height: 7px !important;
  border-radius: 2px !important;
  position: absolute;
  top: -40px;
  left: -25px;
  overflow: hidden;
}

.bocaDeLobo div {
  z-index: 1;
  background: #8d8d8d !important;
  min-width: 6px !important;
  max-width: 6px !important;
  height: 10px !important;
  border-radius: 0px !important;
  left: 28px;
  position: absolute;
}

.hidrante {
  z-index: 3;
  min-width: 14px !important;
  max-width: 14px !important;
  height: 25px !important;
  background: red !important;
  border-radius: 0px 0px 2px 2px !important;
  top: -68px;
  left: 4px;
  box-shadow: 0 15px 7px #00000062;
}

.hidrante .topo {
  position: absolute;
  height: 10px !important;
  min-width: 18px !important;
  max-width: 18px !important;
  left: -7px;
  border-bottom: 1px solid rgb(22, 22, 22);
  top: -8px;
  background: red !important;
  border-radius: 50% 50% 2px 2px !important;
}

.hidrante .braco {
  position: absolute;
  height: 10px !important;
  min-width: 20px !important;
  max-width: 20px !important;
  left: -8px;
  top: -4px;
  border-left: 1px solid black;
  border-right: 1px solid black;
  background: red !important;
  border-radius: 40% !important;
}

.faixaPedestre{
  background: #636363 !important;
  min-width: 50px !important;
  max-width: 50px !important;
  height: 80px !important;
  border-radius: 0px !important;
  top: -35px;
  left: -14px;
}

.faixaPedestre div{
  background: white !important;
  min-width: 50px !important;
  max-width: 50px !important;
  height: 10px !important;
  border-radius: 0px !important;
  margin: 5px 0px !important;
}

@keyframes drive {
  0% {
    transform: translateX(-80px);
  }

  100% {
    transform: translateX(-1200%);
  }
}

.toggleMonitoramento{
  min-width: 100%;
  position: relative;
}

.toggleLegend{
  position: absolute;
  margin-top: 29px;
  right: 25px;
  z-index: 10;
}

.switch {
  position: relative;
  display: inline-block;
  width: 26px;
  height: 14px;
}

.switch input { 
  opacity: 0;
  width: 0;
  height: 0;
}

.sliderButton {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
}

.sliderButton:before {
  position: absolute;
  content: "";
  height: 10px;
  width: 10px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  transition: .4s;
}

input:checked + .sliderButton {
  background-color: #646464;
}

input:focus + .sliderButton {
  box-shadow: 0 0 1px #646464;
}

input:checked + .sliderButton:before {
  transform: translateX(12px);
}

/* Rounded sliderButtons */
.sliderButton.round {
  border-radius: 34px;
}

.sliderButton.round:before {
  border-radius: 50%;
}

.cadastroModel{
  font-size: 13px;
  display: flex;
  cursor: pointer;
  padding: 6px 0px;
  margin: 4px 0px;
  border: 1px solid #b3b3b3;
  border-radius: 10px;
  transition: .5s;
}

.cadastroModel.disabled{
  background: #00000015;
  margin: 0px;
  padding: 0px;
  border-radius: 0px;
  border: none;
  color: #00000080;
}

.cadastroModel.initial{
  margin: 0px;
  padding: 0px;
  border-radius: 0px;
  border: none;
}

.gridCadatroBall{
  width: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
}

.cadastroBall{
  font-weight: bold;
  padding: 2px 5px;
  border-radius: 50px;
  color: #fff;
  pointer-events: none;
}

.cadastroModel.disabled .cadastroBall{
  color: #ffffff67;
  font-size: 11px;
}

.cadastroName{
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
}

.legendFilter{
  position: absolute;
  right: 0%;
  max-width: 27px !important;
}

.legendFilter.up{
  top: -15px;
}

.registerMode{
  font-family: 'Courier Prime', monospace;
  pointer-events: none;
  font-size: 14px;
  font-weight: bold;
  color: #646464;
}

.registerMode.firstRegister{
  margin-top: 0px;
}

.registerModeDesc{
  font-size: 11px;
  color: #666666;
  font-weight: 400;
  max-width: 90%;
  min-width: 90%;
}

.smallFont{
  font-size: 11px;
  margin: 13px 0px;
}

.descSpace{
  margin-top: 0px !important;
}

.descStrong{
  font-weight: bold;
  text-decoration: underline;
  display: inline;
}

#fixedFilter{
  position: sticky;
  top: 200px !important;
}

._2c50p{
  background: #fff;
  cursor: pointer;
}

._-LJ2W li{
  margin-top: 10px;
  border: 1px solid #000;
  display: flex;
  justify-content: center;
  align-items: center;
}

._-cAh3._19gvi{
  border: 1px solid #145fff;
}

._L8X8r{
  height: 100%;
  align-items: initial;
}

.rugosidadeChartInfo{
  font-size: 13px;
  color: #646464;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
}

.infoSeparate{
  width: 100%;
  height: 1px;
  background-color: #9e9e9e;
  margin: 15px 0px;
}

.totalAvaliated{
  width: 100%;
  max-height: 120px;
  display: flex;
}

.descriptionAvaliated{
  font-family: 'Courier Prime', monospace;
  color: #666666;
  font-size: 12px;
  min-width: 40%;
  max-width: 40%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.chartAvaliated{
  pointer-events: none;
  min-width: 60%;
  max-width: 60%;
  max-height: 120px;
}

.chartAvaliated div canvas{
  min-width: 100%;
  max-width: 100%;
  max-height: 120px;
}

.extensionFilter{
  position: absolute;
  width: 100%;
  height: 50px;
  margin-top: -51px;
  margin-left: 0px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 40px;
  color: #666666;
  text-align: center;
  z-index: 1;
}

.filterBtn{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  margin-left: -15px;
}

.filterBtn i{
  padding: 3px;
  border: 1px solid #666666;
  border-radius: 5px;
  cursor: pointer;
}

.centerElementsExtensionText{
  display: flex;
  flex-direction: row;
  align-items: center;
  /* white-space: nowrap; */
  font-size: 12px;
}

.centerElementsExtensionText div{
  display: flex;
  justify-content: initial;
  padding-left: 15px;
}

.centerElementsExtension{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  /* white-space: nowrap; */
  font-size: 12px;
}

.centerElementsExtension div i{
  font-size: 10px;
  margin-left: 35px;
  padding-right: 5px;
}

.inputExtensionCenter{
  font-family: 'Montserrat', sans-serif;
  width: 100%;
  display: grid;
  grid-template-columns: 10% 70%;
}

.infoExtension{
  position: relative;
  font-family: 'Courier Prime', monospace;
  font-size: 10px;
  /* padding-left: 15px; */
  display: flex;
  justify-content: center;
  align-items: center;
}

.inputExtension{
  width: 100%;
  height: 17px;
  margin-left: 3px;
  padding-left: 5px;
  border-radius: 20px;
  border: 1px solid #d9d9d9;
  background: #d9d9d9;
}

.inputExtension:focus {
  outline: none;
}

.inputExtension.active{
  animation: popupWarning 1.5s infinite;
}

#popupExtension{
  display: none;
  right: -25%;
  top: -44px;
  background: #fff;
  border-radius: 5px 5px 0px 5px;
  position: absolute;
  min-width: 200px;
  white-space: normal;
  border: 1px solid #ff4343;
  padding: 5px;
  font-weight: bold;
  color: #ff4343;
  animation: popupWarning 1.5s infinite;
  transition: .5s;
}

@keyframes popupWarning{
	0%{
    border: 1px solid #ff4343;
	}
	50%{
    border: 1px solid #d9d9d9;
	}
	100%{
    border: 1px solid #ff4343;
	}
}

.mapboxgl-popup-close-button{
  position: absolute;
  font-size: 17px;
  font-weight: bold;
  top: 0px;
  right: 0px;
  height: 15px;
  width: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.mapboxgl-popup-close-button:hover{
  background: rgb(182, 164, 164) !important;
}

.chart-container{
  max-width: 100%;
  min-width: 100%;
  font-size: 12px;
  font-family: 'Courier Prime', monospace;
  color: #646464;
}

/* .chart-container div{
  width: 100%;
}

.chart-container div canvas{
  width: 100% !important;
} */

.listOfModes{
  display: inline-block;
  font-size: 10px;
  border:  none;
  border-radius: 15px;
  padding: 5px;
  margin-left: 5px;
  background: #d9d9d9;
  color: #646464;
}

.chart-container-title{
  font-size: 13px;
  font-family: 'Montserrat', sans-serif;
  margin-bottom: 13px;
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAEA;IACI,eAAe;IACf,SAAS;IACT,UAAU;IACV,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;EAEE;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,UAAU;EACZ;;;AAGF;IACI,aAAa;IACb,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,QAAQ;IACR,UAAU;IACV,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,8CAA8C;IAC9C,eAAe;IACf,aAAa;IACb,YAAY;IACZ,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;EACE,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,MAAM;EACN,OAAO;EACP,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,kCAAkC;EAClC,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;AACjB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;IACI;AACJ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,eAAe;EACf,WAAW;AACb;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;IACI,oBAAoB;IACpB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,QAAQ;IACR,SAAS;IACT,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,4CAA4C;IAC5C,kCAA0B;YAA1B,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI;QACI,oCAAoC;QACpC,kBAAkB;QAClB,gBAAgB;QAChB,eAAe;QACf,WAAW;QACX,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,2CAA2C;IAC/C;;IAEA;QACI,2CAA2C;IAC/C;;IAEA;QACI,2CAA2C;IAC/C;;IAEA;QACI,2CAA2C;IAC/C;AACJ;;AAEA;IACI,wCAAgC;YAAhC,gCAAgC;AACpC;;AAEA;IACI,wCAAgC;YAAhC,gCAAgC;AACpC;;AAEA;IACI,wCAAgC;YAAhC,gCAAgC;AACpC;;AAEA;IACI,wCAAgC;YAAhC,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,wBAAwB;IACxB,iCAAiC;AACrC;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,UAAU;IACV,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,SAAS;IACT,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,QAAQ;IACR,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,sCAAsC;IACtC,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,iCAAiC;IACjC,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,6DAA6D;AACjE;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,YAAY;IACZ,aAAa;IACb,6BAA6B;IAC7B,eAAe;IACf,QAAQ;IACR,SAAS;IACT,aAAa;IACb,aAAa;IACb,UAAU;IACV,uBAAuB;IACvB,mBAAmB;IACnB,wBAAwB;AAC5B;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,sCAAsC;IACtC,oBAAoB;IACpB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,mBAAmB;IACnB,mBAAmB;IACnB,6CAA6C;IAC7C,aAAa;IACb,6CAA6C;AACjD;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,wBAAwB;IACxB,eAAe;IACf,WAAW;IACX,oCAAoC;AACxC;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,wBAAwB;IACxB,iCAAiC;AACrC;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,SAAS;IACT,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,sCAAsC;IACtC,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,iCAAiC;IACjC,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,6DAA6D;AACjE;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;IACf,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,QAAQ;IACR,SAAS;IACT,aAAa;IACb,SAAS;IACT,sCAAsC;IACtC,mBAAmB;IACnB,YAAY;IACZ,oDAAoD;IACpD,4CAA4C;AAChD;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,YAAY;AAChB;;AAEA,gBAAgB;AAChB;IACI,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,yBAAyB;IACzB,gBAAgB;IAChB,8BAA8B;IAC9B,UAAU;IACV,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uCAAuC;IACvC,WAAW;EACb;EACA,gBAAgB;;EAEhB;CACD,YAAY;CACZ,aAAa;CACb,4BAA4B;CAC5B,eAAe;CACf,QAAQ;CACR,SAAS;CACT,eAAe;CACf,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,gCAAgC;CAChC,YAAY;CACZ,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,aAAa;CACb,mBAAmB;CACnB,gCAAgC;AACjC;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;;;AAGA;CACC;EACC,SAAS;CACV;CACA;EACC,YAAY;CACb;CACA;EACC,SAAS;CACV;AACD;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,yBAAiB;YAAjB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,qBAAqB;IACrB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,8BAA8B;IAC9B,2BAA2B;IAC3B,8CAA8C;IAC9C,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,qBAAqB;IACrB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,8BAA8B;IAC9B,2BAA2B;IAC3B,8CAA8C;IAC9C,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,8BAA8B;IAC9B,gCAAgC;IAChC,YAAY;IACZ,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,6EAA6E;IAC7E,eAAe;AACnB;;AAEA;IACI,4EAA4E;IAC5E,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,8BAA8B;IAC9B,gCAAgC;IAChC,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,8EAA8E;IAC9E,eAAe;AACnB;;AAEA;IACI,8EAA8E;IAC9E,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,8BAA8B;IAC9B,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,SAAS;AACX;;AAEA;EACE,yBAAiB;UAAjB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,gCAAgC;EAChC,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,yCAAyC;IACzC,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;IACb,cAAc;EAChB;EACA;IACE,UAAU;IACV,aAAa;EACf;EACA;;;;IAME,sBAAsB;EACxB;EACA;IACE,SAAS;IACT,SAAS;IACT,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,yBAAyB;EAC3B;EACA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;;;IAGE,aAAa;EACf;EACA;IACE,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;EACrB;AACF;;IAEI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;;IAEI,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,YAAY;AAChB;AACA;;IAEI,mBAAmB;AACvB;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iCAAiC;IACjC,oCAAoC;IACpC,iCAAiC;IACjC,4CAA4C;IAC5C,0BAA0B;AAC9B;;AAEA;;;IAGI,oCAAoC;AACxC;AACA;;;IAGI,iCAAiC;AACrC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,kCAAkC;AACtC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,yBAAiB;YAAjB,iBAAiB;IACjB,UAAU;IACV,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,sCAAsC;IACtC,gCAAgC;IAChC,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,eAAe;IACf,+CAA+C;AACnD;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uCAAuC;IACvC,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,OAAO;EACP,gBAAgB;EAChB,gCAAgC,EAAE,8BAA8B;EAChE,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,aAAa;IACb,uBAAuB;IACvB,oBAAoB;IACpB,iBAAiB;IACjB,+BAA+B;IAC/B,YAAY;IACZ,aAAa;IACb,cAAc;IACd,UAAU;IACV,oBAAoB;IACpB,eAAe;IACf,cAAc;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,gCAAgC,EAAE,8BAA8B;EAChE,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,wCAAwC;AAC5C;;AAEA;;GAEG;;AAEH,UAAU;AACV;IACI,mBAAmB;AACvB;;AAEA,WAAW;AACX;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,yBAAiB;YAAjB,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,WAAW;IACX,8BAA8B;IAC9B,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;IACI,yBAAiB;YAAjB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAEhB,gBAAgB;IAChB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;IACV,2CAA2C;AAC/C;;AAEA;IACI,eAAe;IACf,cAAc;IACd,uCAAuC;IACvC,WAAW;AACf;;AAEA;EACE,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;AACzB;;;AAGA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;IACvB,+BAA+B;EACjC;;EAEA;IACE,yBAAyB;IACzB,6BAA6B;EAC/B;AACF;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,kCAA0B;UAA1B,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;IACV,uDAAuD;EACzD;;EAEA;IACE,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;AAEF;;AAEA;EACE;IACE,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,oBAAoB;IACpB,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,oDAAoD;IACpD,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA,aAAa;;AAEb;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,iCAAiC;EACjC,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;;;;;;;;GAQG;;AAEH;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mDAAmD;EACnD,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;EAC3B,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;EACV,WAAW;EACX,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;EACV,WAAW;EACX,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;EACV,WAAW;EACX,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,kCAAkC;AAClC;;EAEE;;IAEE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;;EAEE;;IAEE,UAAU;EACZ;;EAEA;;IAEE,UAAU;EACZ;AACF;;AAEA;;EAEE;;IAEE,UAAU;EACZ;;EAEA;;IAEE,UAAU;EACZ;AACF;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,QAAQ;EACR,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,UAAU;EACV,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,UAAU;EACV,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,0BAA0B;EAC1B,0BAA0B;EAC1B,yBAAyB;EACzB,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,UAAU;EACV,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,uBAAuB;EACvB,0BAA0B;EAC1B,0BAA0B;EAC1B,6BAA6B;EAC7B,uEAAuE;EACvE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,SAAS;EACT,SAAS;EACT,uBAAuB;EACvB,0BAA0B;EAC1B,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,sCAAsC;EACtC,0BAA0B;EAC1B,0BAA0B;EAC1B,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,8BAA8B;EAC9B,yBAAyB;EACzB,yBAAyB;EACzB,uBAAuB;EACvB,6BAA6B;EAC7B,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;EACvB,0BAA0B;EAC1B,yCAAyC;EACzC,UAAU;EACV,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,0BAA0B;EAC1B,0BAA0B;EAC1B,UAAU;EACV,wCAAwC;EACxC,SAAS;EACT,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,0BAA0B;EAC1B,0BAA0B;EAC1B,UAAU;EACV,SAAS;EACT,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;EACvB,6BAA6B;EAC7B,UAAU;EACV,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;EACvB,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EAEtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EAEvB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EAGE,2BAA2B;AAC7B;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uCAAuC;EACvC,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,uCAAuC;EACvC,cAAc;EACd,eAAe;EACf,cAAc;EACd,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,uCAAuC;EACvC,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,WAAW;EACX,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,eAAe;EACf,wBAAwB;EACxB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,qCAAqC;EACrC,eAAe;AACjB;;AAEA;CACC;IACG,yBAAyB;CAC5B;CACA;IACG,yBAAyB;CAC5B;CACA;IACG,yBAAyB;CAC5B;AACD;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,eAAe;EACf,eAAe;EACf,uCAAuC;EACvC,cAAc;AAChB;;AAEA;;;;;;GAMG;;AAEH;EACE,qBAAqB;EACrB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;AAClB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Courier+Prime:wght@400;700&family=Montserrat:wght@100;300;400;500;600;700;800;900&display=swap');\n\nbody {\n    cursor: default;\n    margin: 0;\n    padding: 0;\n    font-family: sans-serif;\n    width: 100vw;\n    height: 100vh;\n    overflow: hidden;\n}\n\n.sidebarGeovista{\n    left: 50px !important;\n}\n\n  #app {\n    width: 100vw;\n    height: 100vh;\n    position: absolute;\n    z-index: 1;\n  }\n\n\nlabel {\n    display: flex;\n    font-size: 13px;\n    position: relative;\n}\n\n.fundoLegenda {\n    top: 0px;\n    right: 0px;\n    z-index: 10;\n    display: flex;\n}\n\n.legenda {\n    background: #ffffff;\n    padding-top: 10px;\n    padding-right: 5px;\n    min-width: 170px;\n    max-width: 300px;\n    max-height: 80vh;\n    border: thin groove rgba(170, 170, 170, 0.596);\n    position: fixed;\n    right: -400px;\n    bottom: 40px;\n    border-radius: 10px 0px 0px 10px;\n    overflow-x: hidden;\n    overflow-y: auto;\n    transition: 0.8s;\n}\n\n.legendRight{\n  display: flex;\n  /* position: relative; */\n}\n\n.chartSpacing{\n  max-width: 60%;\n  margin-left: 10px;\n}\n\n.chartSpacing div canvas{\n  max-width: 100%;\n  min-width: 100%;\n  padding-top: 4px;\n}\n\n.changeTextColor{\n  font-family: 'Courier Prime', monospace;\n  white-space: nowrap;\n  height: 23px;\n  font-size: 10px;\n}\n\n.legendaChart {\n  background: #fff;\n  max-width: 70%;\n  font-size: 13px;\n  max-height: 100vw;\n  overflow: hidden;\n  transition: 0.8s;\n  cursor: pointer;\n  padding-top: 5px;\n}\n\n.legendaChart.centerRugosidadeLegend {\n  padding-top: 10px;\n}\n\n.legendTitle{\n  width: 100%;\n  text-align: center;\n  color: #a8a8a8;\n  font-size: 15px;\n  font-weight: bold;\n  border-radius: 7px;\n  border: 1px solid #a8a8a8;\n  margin-bottom: 15px;\n  transition: .5s;\n}\n\n.infoLegendBlocked{\n  background: #fff;\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  text-align: center;\n  text-align: justify;\n  opacity: 0;\n  top: 0;\n  left: 0;\n  font-size: 12px;\n  height: 100%;\n  padding: 35px 5px;\n  box-shadow: 0px 0px 15px #0000006c;;\n  transition: .3s;\n  z-index: 1;\n}\n\n.infoLegendBlocked.active{\n  opacity: 1;\n}\n\n.arrowIcon{\n  position: absolute;\n  top: 1px;\n  left: 6px;\n  font-size: 26px;\n}\n\n.centerLegendaChart{\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.legenda.active{\n    right: -1px;\n}\n\n#legendaIA {\n    display: flex;\n    width: 300px;\n}\n\n#legendaRugosidade {\n    display: flex;\n    min-width: 170px;\n    max-width: 220px;\n}\n\n.legendMode{\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    margin: 0px 20px;\n    margin-bottom: 10px;\n    width: 87%;\n}\n\n.legendMode div{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.legendMode div span{\n  padding: 4px 10px;\n  border-radius: 7px;\n  background: #cccccc;\n  cursor: pointer;\n  transition: .4s;\n  font-weight: bold;\n  color: #fff;\n  border: 1px solid #e0e0e0;\n}\n\n.legendMode div span:hover{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  background: #6aaaff;\n  border: 1px solid #a9ceff;\n}\n\na:link {\n  text-decoration: none;\n}\n\na:visited {\n  color: black;\n  text-decoration: none;\n}\n\na:hover {\n  text-decoration: none;\n}\n\na:active {\n  text-decoration: none;\n}\n\n.trocarCor {\n  margin-right: 10px;\n  position: relative;\n  background: #ffffffdc;\n  vertical-align: middle;\n  min-width: 18px;\n  max-width: 18px;\n  min-height: 18px;\n  max-height: 18px;\n  border: 2px solid #3a3a3adc;\n  margin-bottom: 5px;\n  border-radius: 10px;\n}\n\n.trocarCor.rugosidadeLegend{\n  min-width: 40px;\n  max-width: 40px;\n  min-height: 11px;\n  max-height: 11px;\n  border-radius: 1px;\n}\n\n.tampa {\n  margin-right: -18px;\n  margin-bottom: -2px;\n  position: relative;\n  background: white;\n  display: flex;\n  min-width: 18px;\n  max-width: 18px;\n  min-height: 18px;\n  max-height: 18px;\n  z-index: 200;\n  border-radius: 10px;\n  display: inline-block;\n}\n\n.tampa.rugosidadeLegend{\n  margin-right: -40px;\n  margin-bottom: 0px;\n  min-width: 40px;\n  max-width: 40px;\n  min-height: 11px;\n  max-height: 11px;\n  border-radius: 1px;\n}\n\n.timeControlCenter{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 100%;\n  max-width: 100%;\n  height: 100%;\n  border-top: 1px solid #c7c7c7;\n}\n\n.TimeControl {\n  display: grid;\n  grid-template-columns: 42px 1fr;\n  background: #ffffff;\n  padding-right: 5px;\n  padding-left: 2px;\n  width: 100%;\n  height: 100%;\n  border-radius: 10px ;\n  transition: .5s;\n}\n\n.TimeControl.active {\n  bottom: 245px\n}\n\n.TimeControl.disable {\n  bottom: -200px\n}\n\n.calendarButton{\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.restoreButton {\n  font-size: 16px;\n  height: 25px;\n  width: 25px;\n  border-radius: 50%;\n  margin: 2px 0px;\n  border: none;\n  background: #d9d9d9;\n  cursor: pointer;\n  color: white;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: .5s;\n}\n\n.restoreButton:hover {\n    background: #c0c0c0\n}\n\n.centerElement{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  width: 100%;\n}\n\n.slideCenter{\n  width: 100%;\n  height: 100%;\n  display: grid;\n  grid-template-columns: 60px 1fr 20px;\n  margin: 0px;\n}\n\n.output{\n  width: 55px;\n  color: #666666;\n}\n\n.slider {\n  -webkit-appearance: none;\n  height: 5px;\n  border-radius: 5px;  \n  background: #acacac;\n  outline: none;\n  opacity: 0.7;\n  transition: .2s;\n  width: 100%;\n}\n\n.slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 15px;\n  height: 15px;\n  border-radius: 50%; \n  background: #646464;\n  cursor: pointer;\n}\n\n.slider::-moz-range-thumb {\n  width: 15px;\n  height: 15px;\n  border-radius: 50%;\n  background: #646464;\n  cursor: pointer;\n}\n\n#fundoMouseRight {\n    pointer-events: none;\n    width: 100vw;\n    height: 100vh;\n    position: fixed;\n    top: 0px;\n    left: 0px;\n    display: none;\n    z-index: 3000;\n}\n\n#bordaCirculo {\n    pointer-events: all;\n    position: absolute;\n    z-index: 5;\n    margin-left: 6px;\n    margin-top: 6px;\n    width: 130px;\n    height: 130px;\n    border: 30px solid rgba(187, 187, 187, 0.77);\n    backdrop-filter: blur(6px);\n    border-radius: 50%;\n}\n\n#clickMouseRight1 {\n    position: absolute;\n    margin-left: -30px;\n    margin-top: -30px;\n    width: 63px;\n    height: 65px;\n    border-radius: 100% 0px 0px;\n}\n\n#clickMouseRight2 {\n    position: absolute;\n    margin-left: 37px;\n    margin-top: -30px;\n    width: 63px;\n    height: 65px;\n    border-radius: 0px 100% 0px 0px;\n}\n\n#clickMouseRight3 {\n    position: absolute;\n    margin-left: -30px;\n    margin-top: 39px;\n    width: 63px;\n    height: 61px;\n    border-radius: 0px 0px 0px 100%;\n}\n\n#clickMouseRight4 {\n    position: absolute;\n    margin-left: 37px;\n    margin-top: 39px;\n    width: 63px;\n    height: 61px;\n    border-radius: 0px 0px 100% 0px;\n}\n\n#clickMouseRight5 {\n    position: absolute;\n    margin-left: 3px;\n    margin-top: 3px;\n    width: 64px;\n    height: 64px;\n    border-radius: 100%;\n}\n\n.iconeMouseRight {\n    width: 28px;\n    position: absolute;\n    margin-top: 17px;\n    margin-left: 17px;\n    filter: invert(100%);\n}\n\n@supports (-moz-appearance: none) {\n    #clickMouseRight5 {\n        background-color: rgb(255, 255, 255);\n        position: absolute;\n        margin-left: 0px;\n        margin-top: 0px;\n        width: 70px;\n        height: 70px;\n        border-radius: 100%;\n    }\n\n    #clickMouseRight1:hover {\n        background-color: rgba(168, 168, 168, 0.77);\n    }\n\n    #clickMouseRight2:hover {\n        background-color: rgba(168, 168, 168, 0.77);\n    }\n\n    #clickMouseRight3:hover {\n        background-color: rgba(168, 168, 168, 0.77);\n    }\n\n    #clickMouseRight4:hover {\n        background-color: rgba(168, 168, 168, 0.77);\n    }\n}\n\n#clickMouseRight1:hover {\n    backdrop-filter: brightness(0.8);\n}\n\n#clickMouseRight2:hover {\n    backdrop-filter: brightness(0.8);\n}\n\n#clickMouseRight3:hover {\n    backdrop-filter: brightness(0.8);\n}\n\n#clickMouseRight4:hover {\n    backdrop-filter: brightness(0.8);\n}\n\n.infoMouseRight {\n    margin-left: -42px;\n    margin-top: 105px;\n    width: 150px;\n    height: 30px;\n    text-align: center;\n}\n\n* {\n    margin: 0;\n    padding: 0;\n}\n\n.formLabel {\n    width: 215px;\n    margin-left: 20px;\n    border: solid 1px white;\n    color: white;\n    font-weight: bold;\n    font-size: 12px;\n    background: #2f77e4;\n    padding: 2px 7px 2px 7px;\n    border-radius: 0px 10px 10px 10px;\n}\n\n.allFilters{\n    padding-top: 15px;\n    margin-left: -500px;\n    opacity: 0;\n    transition: opacity .3s, margin-left 0.8s;\n}\n\n.allFilters.active {\n    margin-left: -10px;\n    opacity: 1;\n}\n\n.topspace{\n    padding-top: 15px;\n}\n\n.tight-gutter {\n    padding: 0 2px;\n}\n\n.filterButton{\n    position: absolute;\n    margin-top: 8px;\n    right: 5%;\n    padding: 2px 5px 2px 5px;\n    font-size: 12px;\n}\n\n.noFilterButton{\n    cursor: pointer;\n    color: #2f77e4 !important;\n    font-weight: 600;\n    position: absolute;\n    margin-top: 10px;\n    left: 5%;\n    padding: 2px;\n    font-size: 10px;\n}\n\n.noFilterButton:hover{\n    font-weight: 1000;\n}\n\n.stopCaptureButton{\n    top: 37px;\n    left: 105px;\n    font-size: 0px;\n    padding-top: 3px;\n    text-align: center;\n    color: white;\n    border: solid 1px rgba(0, 0, 0, 0.541);\n    width: 0;\n    height: 0;\n    background:#2f77e4;\n    border-radius: 0px 10px 10px 10px;\n    border: none;\n    z-index: 500;\n    position: absolute;\n    transition: width 0.5s, height 0.5s, top 0.5s, font-size 0.5s;\n}\n\n.stopCaptureButton.active{\n    width: 150px;\n    height: 30px;\n    top: 37px;\n    font-size: 15px;\n}\n\n.emailFormCenter {\n    pointer-events: none;\n    width: 100vw;\n    height: 100vh;\n    background: rgba(0, 0, 0, .5);\n    position: fixed;\n    top: 0px;\n    left: 0px;\n    z-index: 2000;\n    display: none;\n    opacity: 0;\n    justify-content: center;\n    align-items: center;\n    transition: opacity 0.8s;\n}\n.emailFormCenter.active{\n    pointer-events: all;\n    display: flex;\n    transition: opacity 0.8s;\n}\n\n.emailFormCenter.opacity{\n    opacity: 1;\n}\n\n.emailFormBody{\n    align-items: center;\n    border: solid 1px rgba(0, 0, 0, 0.575);\n    pointer-events: none;\n    position: relative;\n    width: 0;\n    height: 0;\n    background: #ffffff;\n    border-radius: 10px;\n    box-shadow: 10px 12px 20px rgba(0, 0, 0, 0.2);;\n    padding: 20px;\n    transition: height 0.8s, width 0.8s, top 0.8s;\n}\n\n.emailFormBody.active {\n    width: 400px;\n    height: 350px;\n    pointer-events: all;\n}\n\n.formEmail{\n    opacity: 0;\n    transition: opacity 0.1s;\n}\n\n.formEmail.active{\n    opacity: 1;\n}\n\n.formInputEmail{\n    border-radius: 5px;\n    border: none;\n    padding: 2px 7px 2px 7px;\n    font-size: 12px;\n    width: 100%;\n    border: solid 1px rgb(124, 124, 124);\n}\n\n.formLabelEmail {\n    border: solid 1px white;\n    color: white;\n    font-weight: bold;\n    font-size: 12px;\n    background: #2f77e4;\n    padding: 2px 7px 2px 7px;\n    border-radius: 0px 10px 10px 10px;\n}\n\n.topmargin{\n    margin-top: 10px;\n}\n.sendEmailButton{\n    top: 25px;\n    left: 105px;\n    font-size: 0px;\n    padding-top: 3px;\n    text-align: center;\n    color: white;\n    border: solid 1px rgba(0, 0, 0, 0.541);\n    width: 0;\n    height: 0;\n    background:#2f77e4;\n    border-radius: 0px 10px 10px 10px;\n    border: none;\n    z-index: 500;\n    position: absolute;\n    transition: width 0.5s, height 0.5s, top 0.5s, font-size 0.5s;\n}\n\n.sendEmailButton.active{\n    width: 160px;\n    height: 52px;\n    top: 36px;\n    font-size: 15px;\n}\n\n.cancelCaptureText{\n    cursor: pointer;\n    opacity: 0;\n    transition: opacity 1s;\n}\n\n.cancelCaptureText.active{\n    opacity: 1;\n}\n\n.sendEmailText{\n    cursor: pointer;\n    opacity: 0;\n    transition: opacity 1s;\n}\n\n.sendEmailText.active{\n    opacity: 1;\n}\n\n.graphicsPanel{\n    padding: 10px;\n    position: absolute;\n    background-color: white;\n    width: 0;\n    height: 0;\n    right: -300px;\n    top: 15px;\n    border: solid 1px rgba(0, 0, 0, 0.514);\n    border-radius: 15px;\n    z-index: 100;\n    /* box-shadow: 7px 7px 5px 1px rgba(0, 0, 0, 0.2); */\n    transition: width .8s, height .8s, right .8s;\n}\n\n.graphicsPanel.active{\n    width: 350px;\n    height: 350px;\n    right: 205px;\n}\n\n/*^autocomplete*/\n.autocomplete {\n    position: relative;\n    display: inline-block;\n  }\n  \n  .autocomplete-items {\n    background-color: #fff;\n    color: black;\n    position: absolute;\n    top: 29px;\n    border: 1px solid #e9e8e8;\n    border-top: none;\n    border-radius: 0px 0px 5px 5px;\n    width: 95%;\n    max-height: 180px;\n    font-size: 12px;\n    z-index: 1000;\n    overflow-y: auto;\n    overflow-x: hidden;\n  }\n  \n  .autocomplete-items div {\n    padding: 10px;\n    cursor: pointer;\n    background-color: #fff; \n  }\n  \n  .autocomplete-items div:hover {\n    background-color: #e9e9e9; \n  }\n  \n  .autocomplete-active {\n    background-color: DodgerBlue !important; \n    color: #fff; \n  }\n  /*$autocomplete*/\n\n  .background {\n\twidth: 100vw;\n\theight: 100vh;\n\tbackground: rgba(0, 0, 0,.5);\n\tposition: fixed;\n\ttop: 0px;\n\tleft: 0px;\n\tz-index: 200000;\n\tdisplay: none;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.background.show {\n\tdisplay: flex;\n}\n\n.loading{\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n\theight: 40px;\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.obj{\n\twidth: 12px;\n\theight: 70px;\n\tbackground: white;\n\tmargin: 0 3px;\n\tborder-radius: 10px;\n\tanimation: loading 0.8s infinite;\n}\n.obj:nth-child(2){\n\tanimation-delay: 0.1s;\n}\n.obj:nth-child(3){\n\tanimation-delay: 0.2s;\n}\n.obj:nth-child(4){\n\tanimation-delay: 0.3s;\n}\n.obj:nth-child(5){\n\tanimation-delay: 0.4s;\n}\n.obj:nth-child(6){\n\tanimation-delay: 0.5s;\n}\n.obj:nth-child(7){\n\tanimation-delay: 0.6s;\n}\n.obj:nth-child(8){\n\tanimation-delay: 0.7s;\n}\n\n\n@keyframes loading{\n\t0%{\n\t\theight: 0;\n\t}\n\t50%{\n\t\theight: 70px;\n\t}\n\t100%{\n\t\theight: 0;\n\t}\n}\n\n.NebulaCentral{\n    z-index: 400;\n    top: 15px;\n    right: 15px;\n    position: absolute;\n    color: white;\n    user-select: none;\n    transition: 0.4s;    \n    width: 180px;\n    transition: .8s;\n}\n\n.NebulaCentral.disable{\n    right: -300px;\n}\n\n.NebulaCentral h3{  \n    border-radius: 5px 5px 0px 0px;\n    background: #106bca; \n    line-height: 90%;\n    text-align: center;\n    font-size: 15px;\n    padding: 10px;\n    padding-bottom: 20px;\n}\n\n.controlNebula ul{\n    border-radius: 5px;\n    background-color: #106bca;\n    margin-top: -20px;\n}\n\n.controlNebula ul li{\n    background: #106bca;  \n    text-align: center;\n    list-style-type: none;\n    padding: 2px;\n    border-radius: 5px;\n    font-size: 13px;    \n    transition: 0.4s;    \n    cursor: pointer;\n}\n\n.controlNebula ul li:hover{\n    font-size: 20px;\n    font-weight: bold;\n}\n\n.controlNebula ul li:active{\n    font-size: 20px;\n    font-weight: bold;\n    background-color: rgb(255, 255, 255);\n}\n\n.zoomPanel{\n    position: absolute;\n    z-index: 2000;\n    display: inline-block;\n    height: 20px;\n    width: 130px;\n    max-width: 20vw;\n    background: rgb(248, 248, 248);\n    color: rgba(0, 0, 0, 0.719);\n    box-shadow: 2px 2px 5px 1px rgba(0, 0, 0, 0.2);\n    border-radius: 50px;\n    right: 20px;\n    bottom: 10px;\n    font-weight: bold;\n    cursor: pointer;\n    user-select: none;\n    transition: .8s;\n}\n\n.zoomPanelSecond{\n    position: absolute;\n    z-index: 2000;\n    display: inline-block;\n    height: 20px;\n    width: 130px;\n    max-width: 20vw;\n    background: rgb(248, 248, 248);\n    color: rgba(0, 0, 0, 0.719);\n    box-shadow: 2px 2px 5px 1px rgba(0, 0, 0, 0.2);\n    border-radius: 50px;\n    right: 5px;\n    bottom: 5px;\n    font-weight: bold;\n    cursor: pointer;\n    user-select: none;\n    transition: .8s;\n}\n\n.zoomPanel.move{\n    right: -200px;\n}\n\n.zoomControlMinus{\n    display: inline-block;\n    background: rgb(255, 255, 255);\n    border-radius: 50px 0px 0px 50px;\n    height: 100%;\n    width: 38%; \n    transition: .5s;\n}\n\n.zoomControlMinus:hover{\n    background: linear-gradient(to left, rgb(255, 255, 255) , rgb(238, 238, 238));\n    transition: .2s;\n}\n\n.zoomControlMinus:active{\n    background: linear-gradient(to left rgb(255, 255, 255) , rgb(233, 233, 233));\n    transition: .2s;\n}\n\n.zoomControlPlus{\n    display: inline-block;\n    background: rgb(255, 255, 255);\n    border-radius: 0px 50px 50px 0px;\n    height: 100%;\n    width: 38%; \n    margin-left: 2px;\n    transition: .5s;\n}\n\n.zoomControlPlus:hover{\n    background: linear-gradient(to right, rgb(255, 255, 255) , rgb(238, 238, 238));\n    transition: .2s;\n}\n\n.zoomControlPlus:active{\n    background: linear-gradient(to right, rgb(255, 255, 255) , rgb(233, 233, 233));\n    transition: .2s;\n}\n\n.minusSymbol{\n    position: absolute;\n    margin-bottom: -5px;\n    bottom: 1px;\n    left: 15px;\n    font-size: 20px;\n}\n\n.plusSymbol{\n    position: absolute;\n    margin-bottom: -4px;\n    bottom: 1px;\n    right: 15px;\n    font-size: 17px;\n}\n\n.orientation{\n    display: inline-block;\n    background: rgb(255, 255, 255);\n    height: 100%;\n    width: 20%; \n    margin-left: 2px;\n    transition: .2s;\n    text-align: center;\n}\n\n.orientation:hover{\n    background: rgb(248, 248, 248);\n}\n\n.orientation:active{\n    background: rgb(240, 240, 240);\n}\n\n.orientation i{\n    color: #000;\n    position: absolute;\n    margin-left: -8px;\n    margin-top: 2px;\n    font-size: 17px;\n    height: 32px;\n    vertical-align: middle;\n}\n\n.calendarHub{\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  /* justify-content: center; */\n  min-height: 270px;\n  bottom: -270px;\n  overflow: hidden;\n  left: -100vw;\n  opacity: 0;\n  transition: .5s;\n  z-index: 10 !important;\n}\n\n.calendarHub.active{\n  bottom: -270px;\n  opacity: 1;\n  left: 0px;\n}\n\n.calendarModule{\n  user-select: none;\n  padding: 6px;\n  background: #fff;\n  color: #2f77e4;\n  border: solid 1px #c7c7c7;\n  border-left: none;\n  border-radius: 0px 10px 10px 0px;\n  width: 80%;\n  cursor: pointer;\n  position: relative;\n  z-index: 20000;\n}\n\n.react-calendar {\n    /* width: 300px; */\n    max-width: 100%;\n    background: white;\n    border: 1px solid #a0a096;\n    font-family: Arial, Helvetica, sans-serif;\n    line-height: 1.125em;\n    font-size: 16px;\n  }\n  .react-calendar--doubleView {\n    width: 700px;\n  }\n  .react-calendar--doubleView .react-calendar__viewContainer {\n    display: flex;\n    margin: -0.5em;\n  }\n  .react-calendar--doubleView .react-calendar__viewContainer > * {\n    width: 50%;\n    margin: 0.5em;\n  }\n  .react-calendar,\n  .react-calendar *,\n  .react-calendar *:before,\n  .react-calendar *:after {\n    -moz-box-sizing: border-box;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n  }\n  .react-calendar button {\n    margin: 0;\n    border: 0;\n    outline: none;\n  }\n  .react-calendar button:enabled:hover {\n    cursor: pointer;\n  }\n  .react-calendar__navigation {\n    display: flex;\n    height: 44px;\n    margin-bottom: 1em;\n  }\n  .react-calendar__navigation button {\n    min-width: 44px;\n    background: none;\n  }\n  .react-calendar__navigation button:disabled {\n    background-color: #f0f0f0;\n  }\n  .react-calendar__navigation button:enabled:hover,\n  .react-calendar__navigation button:enabled:focus {\n    background-color: #e6e6e6;\n  }\n  .react-calendar__month-view__weekdays {\n    text-align: center;\n    text-transform: uppercase;\n    font-weight: bold;\n    font-size: 16px;\n  }\n  .react-calendar__month-view__weekdays__weekday {\n    padding: 0.5em;\n  }\n  .react-calendar__month-view__weekNumbers .react-calendar__tile {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 16px;\n    font-weight: bold;\n  }\n  .react-calendar__month-view__days__day--weekend {\n    color: #d10000;\n  }\n  .react-calendar__month-view__days__day--weekend:disabled {\n    color: #d1000067;\n  }\n  .react-calendar__month-view__days__day--neighboringMonth {\n    color: #757575;\n  }\n  .react-calendar__year-view .react-calendar__tile,\n  .react-calendar__decade-view .react-calendar__tile,\n  .react-calendar__century-view .react-calendar__tile {\n    padding: 15px;\n  }\n  .react-calendar__tile {\n    max-width: 100%;\n    padding: 10px 6.6667px;\n    background: none;\n    text-align: center;\n    line-height: 16px;\n  }\n  .react-calendar__tile:disabled {\n    background-color: #f0f0f0;\n  }\n  .react-calendar__tile:enabled:hover,\n  .react-calendar__tile:enabled:focus {\n    background-color: #e6e6e6;\n  }\n  .react-calendar__tile--now {\n    background: #ffff76;\n  }\n.react-calendar__tile--now:enabled:hover,\n.react-calendar__tile--now:enabled:focus {\n    background: #ffffa9;\n}\n.react-calendar__tile--hasActive {\n    background: #76baff;\n}\n.react-calendar__tile--hasActive:enabled:hover,\n.react-calendar__tile--hasActive:enabled:focus {\n    background: #a9d4ff;\n}\n.react-calendar__tile--active {\n    background: #1087ff;\n    color: white;\n}\n.react-calendar__tile--active.active {\n    background: #000000;\n    color: white;\n}\n.react-calendar__tile--active:enabled:hover,\n.react-calendar__tile--active:enabled:focus {\n    background: #1087ff;\n}\n.react-calendar--selectRange .react-calendar__tile--hover {\n    background-color: #e6e6e6;\n}\n\n.mapboxgl-popup-content {\n    background-color: #fff !important;\n    /* border-radius: 20px !important; */\n    border: solid 1px #000 !important;\n    box-shadow: 5px 5px 6px #00000041 !important;\n    transition: .4s !important;\n}\n\n.mapboxgl-popup-anchor-top .mapboxgl-popup-tip,\n.mapboxgl-popup-anchor-top-left .mapboxgl-popup-tip,\n.mapboxgl-popup-anchor-top-right .mapboxgl-popup-tip {\n    border-bottom-color: #fff !important;\n}\n.mapboxgl-popup-anchor-bottom .mapboxgl-popup-tip,\n.mapboxgl-popup-anchor-bottom-left .mapboxgl-popup-tip,\n.mapboxgl-popup-anchor-bottom-right .mapboxgl-popup-tip {\n    border-top-color: #fff !important;\n}\n.mapboxgl-popup-anchor-left .mapboxgl-popup-tip {\n    border-right-color: #fff !important;\n}\n.mapboxgl-popup-anchor-right .mapboxgl-popup-tip {\n    border-left-color: #fff !important;\n}\n\n.popupFormat{\n    display: flex;\n}\n\n.popupFormatInfo{\n    padding: 0px 10px;\n}\n\n#popupInfo{\n    position: absolute;\n    opacity: 0;\n    max-width: 800px;\n    max-height: 200px;\n    background: #fff;\n    white-space: nowrap;\n    border: solid 1px #d4d4d4;\n    border-radius: 10px;\n    padding: 3px;\n    font-size: 14px;\n    z-index: 20000;\n    pointer-events: none;\n    transition: .2s;\n}\n\n.restoreMap {\n    overflow: hidden;\n    position: absolute;\n    z-index: 30500;\n    user-select: none;\n    top: -20px;\n    left: 95px;\n    margin-top: -50px;\n    padding-top: 12px;\n    background: #fff;\n    color: #2f77e4;\n    text-align: center;\n    border: solid 1px rgba(0, 0, 0, 0.541);\n    border-radius: 0px 0px 10px 10px;\n    font-size: 14px;\n    line-height: 15px;\n    height: 50px;\n    width: 33px;\n    pointer-events: none;\n    cursor: pointer;\n    transition: .5s;\n    box-shadow: 5px 12px 5px 1px rgba(0, 0, 0, 0.2);\n}\n\n.restoreMap.active {\n    width: 150px;\n    height: 72px;\n    top: 36px;\n    pointer-events: all;\n}\n\n.restoreMap ul li {\n    list-style: none;\n    padding: 7px;\n}\n\n.restoreMap ul li.active {\n    background: #2f77e4;\n    color: #fff;\n    width: 100%;\n    height: 100%;\n}\n\n#rectCanvas{\n    z-index: 9000;\n    position: absolute;\n    /* background: rgba(255, 0, 0, 0.534); */\n}\n\n.titleFormat{\n    display: flex;\n    font-size: 23px;\n    font-weight: bold;\n    max-width: 200px;\n}\n\n.titleInfo{\n    padding-left: 3px;\n}\n\n.dateInfo{\n    color: #84DAFF;\n}\n\n.contentFormat{\n    font-family: 'Courier Prime', monospace;\n    color: #666666;\n    padding-left: 3px;\n    padding-top: 10px;\n    font-size: 12px;\n}\n\n.contentFormat p{\n    margin: 0px;\n}\n\n.centerConditionElement{\n  height: 25px;\n  width: 100%;\n  margin-top: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.conditionElement{\n  font-family: 'Montserrat', sans-serif;\n  font-weight: bold;\n  font-size: 11px;\n  height: 100%;\n  width: 90%;\n  color: #646464;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.conditionElement.ativa{\n  background: #fff500;\n}\n\n.conditionElement.encerrada{\n  background: #75ff93;\n}\n\n.expandImageButton{\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  right: 2%;\n  top: 2%;\n  color: #ffffffa8;\n  -webkit-text-stroke: 1px #b8b8b8; /* Largura e cor do contorno */\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 30px;\n  font-weight: bold;\n  width: 40px;\n  height: 40px;\n  z-index: 111000;\n}\n\n.expandImageButton:hover{\n  color: #ffffff;\n}\n\n#fundoExpandedImage{\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    display: flex;\n    justify-content: center;\n    align-items: initial;\n    padding-top: 30px;\n    background: rgba(0, 0, 0, 0.37);\n    width: 100vw;\n    height: 100vh;\n    z-index: 10000;\n    opacity: 0;\n    pointer-events: none;\n    transition: .2s;\n    overflow: auto;\n}\n\n.closeExpandedImage{\n  position: fixed;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  right: 5.2%;\n  top: 5.2%;\n  color: #ffffffa8;\n  -webkit-text-stroke: 1px #b8b8b8; /* Largura e cor do contorno */\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 45px;\n  font-weight: bold;\n  width: 40px;\n  height: 40px;\n  z-index: 111000;\n}\n  \n.closeExpandedImage:hover{\n  color: #ffffff;\n}\n\n#expandedImage{\n    position: absolute;\n    /* top: -120vh; */\n}\n\n#rectCanvasExpanded{\n    position: absolute;\n    z-index: 110000;\n    /* background: rgba(255, 0, 0, 0.473); */\n}\n\n/* ::-webkit-scrollbar {\n    width: 5px;\n} */\n  \n/* Track */\n::-webkit-scrollbar-track {\n    background: #ffffff;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n    background: #bbbbbb;\n    border-radius: 10px;\n}\n\n.FilterCentral {\n    z-index: 400;\n    color: #666666;\n    user-select: none;\n    transition: 0.4s;\n    width: 100%;\n}\n\n.FilterCentral h3 {\n    width: 100%;\n    background: #fff;\n    line-height: 90%;\n    text-align: center;\n    font-size: 15px;\n    font-weight: bold;\n    padding: 10px;\n    padding-bottom: 20px;\n}\n\n.controlFilter{\n    width: 100%;\n    font-family: 'Montserrat', sans-serif;\n}\n\n.controlFilter ul {\n    display: grid;\n    width: 100%;\n    grid-template-columns: 1fr 1fr;\n    background-color: #fff;\n    margin-bottom: 0px;\n}\n\n.lastFilterElement {\n    grid-column-start: 1;\n    grid-column-end: 3;\n    grid-row-start: 3;\n    grid-row-end: 3;\n}\n\n.controlFilter ul li {\n    background: #fff;\n    text-align: center;\n    list-style-type: none;\n    border-radius: 8px;\n    padding: 1px;\n    font-size: 12px;\n    transition: 0.4s;\n    cursor: pointer;\n}\n\n.controlFilter ul li:active {\n    background-color: rgb(255, 255, 255);\n}\n\n.controlFilter ul li.active {\n    background-color: rgb(235, 235, 235);\n    color: #000;\n}\n\n.barraFilter{\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 2px;\n    margin-left: 0px;\n  }\n  \n  .completeLabel{ \n    width: 100%; \n    margin-top: 3px;\n}\n\n.completeLabel form{ \n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.formInput {\n    width: 100%;\n    border-radius: 0px;\n    padding: 2px 7px 2px 7px;\n    padding-left: 30px;\n    font-size: 12px;\n    border: solid 1px #b9b9b9;\n    border-left: none;\n    border-right: none;\n    margin-left: 0px;\n}\n\nspan.fas.fa-search {\n  position: absolute;\n  top: 15px;\n  left: 7px;\n  transform: translateY(-50%);\n  color: #888;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.topElement{\n    user-select: none;\n    align-items: center;\n    background: #fff;\n    position: -webkit-sticky;\n    position: sticky;\n    top: 0px;\n    left: 0px;\n    width: 100%;\n    height: 90px;\n    z-index: 2;\n    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.5);\n}\n\n.classDescription{\n    font-size: 11px;\n    color: #666666;\n    font-family: 'Courier Prime', monospace;\n    width: 100%;\n}\n\n#fundoSplashScreen {\n  z-index: 10000;\n  user-select: none;\n  overflow: hidden;\n  margin: 0px;\n  padding: 0px;\n  height: 100vh;\n  width: 100vw;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  animation: slide-up .4s;\n}\n\n\n.loader {\n  border: 8px solid #f3f3f3;\n  border-top: 8px solid #3498db;\n  border-radius: 50%;\n  width: 250px;\n  height: 250px;\n  animation: spin 2.5s linear infinite;\n  margin: 0 auto;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n    /* ângulo inicial da animação */\n  }\n\n  100% {\n    transform: rotate(360deg);\n    /* ângulo final da animação */\n  }\n}\n\n.splash {\n  z-index: 10;\n  pointer-events: none;\n  position: relative;\n  width: 250px;\n  height: 250px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n  border-radius: 50%;\n  margin-top: -200px;\n  backdrop-filter: blur(4px);\n}\n\n.splash.start {\n  animation: startAnimation 4s;\n  animation-timing-function: ease-in-out;\n}\n\n.splash.finish {\n  animation: finishAnimation 3s;\n}\n\n.splash-text {\n  position: absolute;\n  font-weight: bold;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  font-size: 30px;\n  color: #fff;\n}\n\n.splash-text.finish {\n  animation: finishAnimation 3s;\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n  }\n\n  50% {\n    transform: scale(1.1);\n  }\n\n  100% {\n    transform: scale(0);\n  }\n}\n\n@keyframes startAnimation {\n  0% {\n    opacity: 0;\n    transform: scale(-1) translateY(-200%) translateX(200%);\n  }\n\n  50% {\n    opacity: 1;\n    transform: scale(1.5);\n  }\n\n  100% {\n    transform: scale(1);\n  }\n\n}\n\n@keyframes finishAnimation {\n  0% {\n    color: #fff;\n    background: transparent;\n    transform: scale(1);\n    opacity: 1;\n  }\n\n  20% {\n    color: #fff;\n    background: transparent;\n    transform: scale(1.5);\n    opacity: 1;\n  }\n\n  50% {\n    color: #dddddd;\n    background: #dddddd;\n    transform: scale(15);\n    opacity: 1;\n  }\n\n  90% {\n    color: #dddddd;\n    background: #dddddd;\n    transform: scale(0) translateY(-50%) translateX(50%);\n    opacity: 1;\n  }\n\n  100% {\n    color: #dddddd;\n    background: #dddddd;\n    transform: scale(0);\n    opacity: 0;\n  }\n}\n\n@keyframes slide-up {\n  0% {\n    transform: translateY(-200%);\n  }\n\n  100% {\n    transform: translateY(0);\n  }\n}\n\n/* City css */\n\n.road {\n  width: 100%;\n  height: 80px;\n  background-color: #636363;\n  position: absolute;\n  bottom: 0;\n}\n\n.line {\n  width: 100%;\n  border-bottom: 10px dashed yellow;\n  margin-top: 30px;\n  height: 20px;\n}\n\n.sidewalk {\n  width: 100%;\n  height: 20px;\n  background-color: #8d8d8d;\n  position: absolute;\n  bottom: 80px;\n}\n\n.building {\n  z-index: 1;\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  width: 150px;\n  height: 300px;\n  background-color: #808080;\n  position: absolute;\n  bottom: 100px;\n  left: 50%;\n  border-radius: 2px 2px 0px 0px;\n  transform: translateX(-50%);\n}\n\n.building div {\n  border-radius: 2px;\n  margin: 10px;\n  width: 30px;\n  height: 40px;\n  background-color: #505050;\n}\n\n.building div.active {\n  background-color: #ffff65;\n  box-shadow: 0 0px 40px #ffff65;\n}\n\n/* .building div.active:hover {\n  background-color: #505050;\n  box-shadow: none;\n}\n\n.building div:hover {\n  background-color: #ffff65;\n  box-shadow: 0 0px 40px #ffff65;\n} */\n\n.sun {\n  width: 150px;\n  height: 150px;\n  background-color: #ffdb58;\n  border-radius: 50%;\n  position: absolute;\n  bottom: 120px;\n  left: 60px;\n}\n\n.sky {\n  width: 100vw;\n  height: 100vh;\n  background-image: linear-gradient(#083647, #1b4261);\n  position: absolute;\n  top: 0;\n}\n\n.moon {\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n  background-color: #ebebeb;\n  position: absolute;\n  box-shadow: 0 0px 60px #fff;\n  right: 20%;\n  top: 10%;\n}\n\n.star {\n  position: absolute;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: 1s;\n}\n\n.star:hover {\n  transform: scale(4);\n}\n\n.star1 {\n  position: absolute;\n  border-radius: 50%;\n  background-color: #fff;\n  width: 2px;\n  height: 2px;\n  box-shadow: 0 0px 30px #fff;\n  animation: star1 2s infinite;\n}\n\n.star2 {\n  position: absolute;\n  border-radius: 50%;\n  background-color: #fff;\n  width: 2px;\n  height: 2px;\n  box-shadow: 0 0px 30px #fff;\n  animation: star2 3s infinite;\n}\n\n.star3 {\n  position: absolute;\n  border-radius: 50%;\n  background-color: #fff;\n  width: 2px;\n  height: 2px;\n  box-shadow: 0 0px 30px #fff;\n  animation: star3 4s infinite;\n}\n\n/* Keyframe animations for stars */\n@keyframes star1 {\n\n  0%,\n  100% {\n    opacity: 0;\n  }\n\n  50% {\n    opacity: 1;\n  }\n}\n\n@keyframes star2 {\n\n  0%,\n  100% {\n    opacity: 0;\n  }\n\n  25%,\n  75% {\n    opacity: 1;\n  }\n}\n\n@keyframes star3 {\n\n  0%,\n  100% {\n    opacity: 0;\n  }\n\n  33.333%,\n  66.666% {\n    opacity: 1;\n  }\n}\n\n.cloud {\n  z-index: 1;\n  width: 200px;\n  height: 100px;\n  background-color: #193d4c;\n  position: absolute;\n  top: 30px;\n  left: -50px;\n  border-radius: 50px;\n  animation: cloudMove 290s linear infinite;\n}\n\n@keyframes cloudMove {\n  0% {\n    transform: translateX(0px);\n  }\n\n  100% {\n    transform: translateX(3000px);\n  }\n}\n\n.car {\n  z-index: 4;\n  position: absolute;\n  right: -650px;\n  bottom: 65px;\n  width: 180px;\n  height: 40px;\n  background-color: #910000;\n  border-radius: 10px;\n  animation: drive 35s linear infinite;\n  box-shadow: 0 20px 20px rgba(0, 0, 0, 0.692);\n}\n\n.car2 {\n  z-index: 4;\n  position: absolute;\n  right: -300px;\n  bottom: 65px;\n  width: 180px;\n  height: 40px;\n  background-color: #1714aa;\n  border-radius: 10px;\n  animation: drive 35s linear infinite;\n  box-shadow: 0 20px 20px rgba(0, 0, 0, 0.692);\n}\n\n.wheel {\n  width: 40px;\n  height: 40px;\n  background-color: black;\n  position: absolute;\n  bottom: -15px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.wheel div {\n  width: 23px;\n  height: 23px;\n  background-color: rgb(148, 148, 148);\n  position: absolute;\n  border-radius: 50%;\n}\n\n.wheel.left {\n  left: 20px;\n}\n\n.wheel.right {\n  right: 20px;\n}\n\n.teto {\n  width: 130px;\n  height: 80px;\n  background-color: #910000;\n  position: absolute;\n  border-radius: 20px;\n  bottom: 0px;\n  left: 50%;\n  transform: translateX(-45px);\n}\n\n.teto2 {\n  width: 130px;\n  height: 80px;\n  background-color: #1714aa;\n  position: absolute;\n  border-radius: 20px;\n  bottom: 0px;\n  left: 50%;\n  transform: translateX(-45px);\n}\n\n.window {\n  width: 90%;\n  height: 35px;\n  background-color: #0f0f0f;\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  top: 7px;\n  left: 50%;\n  transform: translateX(-50%);\n  border-radius: 10px 10px 3px 3px;\n}\n\n.window div {\n  width: 10px;\n  height: 100%;\n  background-color: #910000;\n}\n\n#roadDetections {\n  position: absolute;\n  height: 40px;\n  bottom: 40px;\n  right: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n#roadDetections div {\n  position: relative;\n  /* opacity: 0; */\n  background: transparent;\n  opacity: 1;\n  height: 30px;\n  min-width: 30px;\n  max-width: 30px;\n  border-radius: 50%;\n  margin: 0px 5px;\n  transition: .6s;\n  /* margin-top: -20px; */\n}\n\n.detect {\n  z-index: 1;\n  top: 0px;\n  left: -4px;\n  position: absolute;\n  background: transparent;\n  min-width: 30px;\n  max-width: 30px;\n  border-radius: 50%;\n}\n\n.tampaDePV {\n  z-index: 0;\n  top: -27px;\n  left: 0px;\n  position: absolute;\n  height: 23px !important;\n  min-width: 23px !important;\n  max-width: 23px !important;\n  border: 3px solid #555555;\n  background: #818181 !important;\n  color: #5e5e5e;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  font-size: 24px;\n}\n\n.tampaDePV div {\n  position: absolute;\n  top: -3px;\n}\n\n.buraco {\n  z-index: 0;\n  top: -27px;\n  left: -9px;\n  position: absolute;\n  height: 23px !important;\n  min-width: 40px !important;\n  max-width: 40px !important;\n  border-top: 2px solid #555555;\n  background-image: linear-gradient(#575757, #555555, #2b2b2b) !important;\n  border-radius: 30%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  font-size: 50px;\n  overflow: hidden;\n}\n\n.buraco div {\n  z-index: 2;\n  position: absolute;\n  top: 3px;\n  left: 0px;\n  font-size: 40px;\n  width: 30px !important;\n  height: 20px !important;\n  background: #666666 !important;\n}\n\n.lixeira {\n  z-index: 3;\n  color: #575757;\n  font-size: 32px;\n  position: absolute;\n  top: -73px;\n  left: -3px;\n}\n\n.lixeira i {\n  position: absolute;\n  z-index: 2 !important;\n}\n\n.lixeira div {\n  position: absolute;\n  z-index: 0 !important;\n  left: 0px;\n  top: 18px;\n  height: 13px !important;\n  min-width: 20px !important;\n  max-width: 20px !important;\n  box-shadow: 0 10px 15px #000000;\n}\n\n.bocaDeLobo {\n  background: rgb(22, 22, 22) !important;\n  min-width: 70px !important;\n  max-width: 70px !important;\n  height: 7px !important;\n  border-radius: 2px !important;\n  position: absolute;\n  top: -40px;\n  left: -25px;\n  overflow: hidden;\n}\n\n.bocaDeLobo div {\n  z-index: 1;\n  background: #8d8d8d !important;\n  min-width: 6px !important;\n  max-width: 6px !important;\n  height: 10px !important;\n  border-radius: 0px !important;\n  left: 28px;\n  position: absolute;\n}\n\n.hidrante {\n  z-index: 3;\n  min-width: 14px !important;\n  max-width: 14px !important;\n  height: 25px !important;\n  background: red !important;\n  border-radius: 0px 0px 2px 2px !important;\n  top: -68px;\n  left: 4px;\n  box-shadow: 0 15px 7px #00000062;\n}\n\n.hidrante .topo {\n  position: absolute;\n  height: 10px !important;\n  min-width: 18px !important;\n  max-width: 18px !important;\n  left: -7px;\n  border-bottom: 1px solid rgb(22, 22, 22);\n  top: -8px;\n  background: red !important;\n  border-radius: 50% 50% 2px 2px !important;\n}\n\n.hidrante .braco {\n  position: absolute;\n  height: 10px !important;\n  min-width: 20px !important;\n  max-width: 20px !important;\n  left: -8px;\n  top: -4px;\n  border-left: 1px solid black;\n  border-right: 1px solid black;\n  background: red !important;\n  border-radius: 40% !important;\n}\n\n.faixaPedestre{\n  background: #636363 !important;\n  min-width: 50px !important;\n  max-width: 50px !important;\n  height: 80px !important;\n  border-radius: 0px !important;\n  top: -35px;\n  left: -14px;\n}\n\n.faixaPedestre div{\n  background: white !important;\n  min-width: 50px !important;\n  max-width: 50px !important;\n  height: 10px !important;\n  border-radius: 0px !important;\n  margin: 5px 0px !important;\n}\n\n@keyframes drive {\n  0% {\n    transform: translateX(-80px);\n  }\n\n  100% {\n    transform: translateX(-1200%);\n  }\n}\n\n.toggleMonitoramento{\n  min-width: 100%;\n  position: relative;\n}\n\n.toggleLegend{\n  position: absolute;\n  margin-top: 29px;\n  right: 25px;\n  z-index: 10;\n}\n\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 26px;\n  height: 14px;\n}\n\n.switch input { \n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.sliderButton {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  -webkit-transition: .4s;\n  transition: .4s;\n}\n\n.sliderButton:before {\n  position: absolute;\n  content: \"\";\n  height: 10px;\n  width: 10px;\n  left: 2px;\n  bottom: 2px;\n  background-color: white;\n  -webkit-transition: .4s;\n  transition: .4s;\n}\n\ninput:checked + .sliderButton {\n  background-color: #646464;\n}\n\ninput:focus + .sliderButton {\n  box-shadow: 0 0 1px #646464;\n}\n\ninput:checked + .sliderButton:before {\n  -webkit-transform: translateX(12px);\n  -ms-transform: translateX(12px);\n  transform: translateX(12px);\n}\n\n/* Rounded sliderButtons */\n.sliderButton.round {\n  border-radius: 34px;\n}\n\n.sliderButton.round:before {\n  border-radius: 50%;\n}\n\n.cadastroModel{\n  font-size: 13px;\n  display: flex;\n  cursor: pointer;\n  padding: 6px 0px;\n  margin: 4px 0px;\n  border: 1px solid #b3b3b3;\n  border-radius: 10px;\n  transition: .5s;\n}\n\n.cadastroModel.disabled{\n  background: #00000015;\n  margin: 0px;\n  padding: 0px;\n  border-radius: 0px;\n  border: none;\n  color: #00000080;\n}\n\n.cadastroModel.initial{\n  margin: 0px;\n  padding: 0px;\n  border-radius: 0px;\n  border: none;\n}\n\n.gridCadatroBall{\n  width: 70px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  pointer-events: none;\n}\n\n.cadastroBall{\n  font-weight: bold;\n  padding: 2px 5px;\n  border-radius: 50px;\n  color: #fff;\n  pointer-events: none;\n}\n\n.cadastroModel.disabled .cadastroBall{\n  color: #ffffff67;\n  font-size: 11px;\n}\n\n.cadastroName{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  pointer-events: none;\n}\n\n.legendFilter{\n  position: absolute;\n  right: 0%;\n  max-width: 27px !important;\n}\n\n.legendFilter.up{\n  top: -15px;\n}\n\n.registerMode{\n  font-family: 'Courier Prime', monospace;\n  pointer-events: none;\n  font-size: 14px;\n  font-weight: bold;\n  color: #646464;\n}\n\n.registerMode.firstRegister{\n  margin-top: 0px;\n}\n\n.registerModeDesc{\n  font-size: 11px;\n  color: #666666;\n  font-weight: 400;\n  max-width: 90%;\n  min-width: 90%;\n}\n\n.smallFont{\n  font-size: 11px;\n  margin: 13px 0px;\n}\n\n.descSpace{\n  margin-top: 0px !important;\n}\n\n.descStrong{\n  font-weight: bold;\n  text-decoration: underline;\n  display: inline;\n}\n\n#fixedFilter{\n  position: sticky;\n  top: 200px !important;\n}\n\n._2c50p{\n  background: #fff;\n  cursor: pointer;\n}\n\n._-LJ2W li{\n  margin-top: 10px;\n  border: 1px solid #000;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n._-cAh3._19gvi{\n  border: 1px solid #145fff;\n}\n\n._L8X8r{\n  height: 100%;\n  align-items: initial;\n}\n\n.rugosidadeChartInfo{\n  font-size: 13px;\n  color: #646464;\n  font-family: 'Montserrat', sans-serif;\n  font-weight: 500;\n}\n\n.infoSeparate{\n  width: 100%;\n  height: 1px;\n  background-color: #9e9e9e;\n  margin: 15px 0px;\n}\n\n.totalAvaliated{\n  width: 100%;\n  max-height: 120px;\n  display: flex;\n}\n\n.descriptionAvaliated{\n  font-family: 'Courier Prime', monospace;\n  color: #666666;\n  font-size: 12px;\n  min-width: 40%;\n  max-width: 40%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.chartAvaliated{\n  pointer-events: none;\n  min-width: 60%;\n  max-width: 60%;\n  max-height: 120px;\n}\n\n.chartAvaliated div canvas{\n  min-width: 100%;\n  max-width: 100%;\n  max-height: 120px;\n}\n\n.extensionFilter{\n  position: absolute;\n  width: 100%;\n  height: 50px;\n  margin-top: -51px;\n  margin-left: 0px;\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 40px;\n  color: #666666;\n  text-align: center;\n  z-index: 1;\n}\n\n.filterBtn{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  margin-left: -15px;\n}\n\n.filterBtn i{\n  padding: 3px;\n  border: 1px solid #666666;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.centerElementsExtensionText{\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  /* white-space: nowrap; */\n  font-size: 12px;\n}\n\n.centerElementsExtensionText div{\n  display: flex;\n  justify-content: initial;\n  padding-left: 15px;\n}\n\n.centerElementsExtension{\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  /* white-space: nowrap; */\n  font-size: 12px;\n}\n\n.centerElementsExtension div i{\n  font-size: 10px;\n  margin-left: 35px;\n  padding-right: 5px;\n}\n\n.inputExtensionCenter{\n  font-family: 'Montserrat', sans-serif;\n  width: 100%;\n  display: grid;\n  grid-template-columns: 10% 70%;\n}\n\n.infoExtension{\n  position: relative;\n  font-family: 'Courier Prime', monospace;\n  font-size: 10px;\n  /* padding-left: 15px; */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.inputExtension{\n  width: 100%;\n  height: 17px;\n  margin-left: 3px;\n  padding-left: 5px;\n  border-radius: 20px;\n  border: 1px solid #d9d9d9;\n  background: #d9d9d9;\n}\n\n.inputExtension:focus {\n  outline: none;\n}\n\n.inputExtension.active{\n  animation: popupWarning 1.5s infinite;\n}\n\n#popupExtension{\n  display: none;\n  right: -25%;\n  top: -44px;\n  background: #fff;\n  border-radius: 5px 5px 0px 5px;\n  position: absolute;\n  min-width: 200px;\n  white-space: normal;\n  border: 1px solid #ff4343;\n  padding: 5px;\n  font-weight: bold;\n  color: #ff4343;\n  animation: popupWarning 1.5s infinite;\n  transition: .5s;\n}\n\n@keyframes popupWarning{\n\t0%{\n    border: 1px solid #ff4343;\n\t}\n\t50%{\n    border: 1px solid #d9d9d9;\n\t}\n\t100%{\n    border: 1px solid #ff4343;\n\t}\n}\n\n.mapboxgl-popup-close-button{\n  position: absolute;\n  font-size: 17px;\n  font-weight: bold;\n  top: 0px;\n  right: 0px;\n  height: 15px;\n  width: 15px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n}\n\n.mapboxgl-popup-close-button:hover{\n  background: rgb(182, 164, 164) !important;\n}\n\n.chart-container{\n  max-width: 100%;\n  min-width: 100%;\n  font-size: 12px;\n  font-family: 'Courier Prime', monospace;\n  color: #646464;\n}\n\n/* .chart-container div{\n  width: 100%;\n}\n\n.chart-container div canvas{\n  width: 100% !important;\n} */\n\n.listOfModes{\n  display: inline-block;\n  font-size: 10px;\n  border:  none;\n  border-radius: 15px;\n  padding: 5px;\n  margin-left: 5px;\n  background: #d9d9d9;\n  color: #646464;\n}\n\n.chart-container-title{\n  font-size: 13px;\n  font-family: 'Montserrat', sans-serif;\n  margin-bottom: 13px;\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
